const SPANISH_UI_TEXT = {
    "Edit ticket": "Editar ticket",
    "Save changes": "Guardar cambios",
    "Disable machine": "Deshabilitar máquina",
    "Disable": "Deshabilitar",
    "Disabled": "Deshabilitada",
    "Do you want to disable": "¿Quieres deshabilitar",
    "The machine record and its history will be kept. It will no longer appear in the active list. You can reactivate it if no other active machine has the same serial number, device ID or external ID.": "Se conservarán el registro y su historial. Dejará de aparecer en la lista de activas. Podrás reactivarla si ninguna otra máquina activa tiene la misma serie, ID de dispositivo o ID externo.",
    "Machine disabled. Its record and history have been preserved.": "Máquina deshabilitada. Se conservaron su registro y su historial.",

    "Conversation": "Conversación",
    "Required": "Obligatorio",
    "At least one photo": "Al menos una foto",
    "Required details": "Datos obligatorios",
    "Complete these details to close the order. Your entries stay here if you close this window.": "Completa estos datos para cerrar la orden. Lo que escribas se conserva si cierras esta ventana.",
    "Requests and parts linked to this order, in one place.": "Solicitudes y repuestos vinculados a esta orden, en un solo lugar.",
    "View chat image": "Ver imagen de la conversación",
    "Customer selections": "Opciones seleccionadas por el cliente",
    "Order data and original report": "Datos de la orden y reporte original",
    "View spare parts": "Ver repuestos",
    "linked parts": "repuestos vinculados",
    "requests": "solicitudes",
    "No customer contact was saved.": "No se guardaron datos de contacto del cliente.",
    "View conversation": "Ver conversación",
    "View issue photo": "Ver foto del problema",
    "Order summary": "Resumen de la orden",
    "The order could not be loaded.": "No se pudo cargar la orden.",
    "No issue description was saved. Check the conversation for context.": "No se guardó una descripción del problema. Revisa la conversación para conocer el contexto.",
    'Send to Customer Support': 'Enviar a Customer Support',
    'Reason for transfer': 'Motivo del traslado',
    'Confirm transfer': 'Confirmar traslado',
    'Customer Support will take responsibility for the claim and review the refund. Open repair orders will leave the technical queue. Completed repairs will keep their technician, completion details and history.': 'Customer Support asumirá la responsabilidad del reclamo y revisará el reembolso. Las órdenes abiertas saldrán de la cola de Técnicos. Las reparaciones completadas conservarán su técnico, los detalles de cierre y su historial.',
    'Use this when the customer selected a technical issue by mistake and needs a refund. Customer Support will take responsibility for the claim and review the refund. The open repair order will leave the technical queue.': 'Usa esta opción cuando el cliente eligió un problema técnico por error y necesita un reembolso. Customer Support asumirá la responsabilidad del reclamo y revisará el reembolso. La orden abierta saldrá de la cola de Técnicos.',

    'Dashboard': 'Panel',
    'General': 'General',
    'Operations': 'Operaciones',
    'Commercial': 'Comercial',
    'People': 'Personas',
    'Analytics & Management': 'Analítica y Gestión',
    'Home': 'Inicio',
    'Analytics': 'Analítica',
    'Administration': 'Administración',
    'Technical Service': 'Servicio técnico',
    'Machine Platforms': 'Plataformas de máquinas',
    'Configuration': 'Configuración',
    'Accounting': 'Contabilidad',
    'Revenue Reconciliation': 'Conciliación de recaudación',
    'Main navigation': 'Navegación principal',
    'Open navigation': 'Abrir navegación',
    'Close navigation': 'Cerrar navegación',
    'Collapse navigation': 'Contraer navegación',
    'Expand navigation': 'Expandir navegación',
    'Monitor key metrics, track performance, and view comprehensive analytics for your operations.': 'Monitorea métricas clave, sigue el rendimiento y visualiza analítica integral de tus operaciones.',
    'User and Role': 'Usuario y rol',
    'Team': 'Equipo',
    'Teams': 'Equipos',
    'Users': 'Usuarios',
    'Select Team': 'Seleccionar equipo',
    'From date': 'Fecha desde',
    'Closed from': 'Cerrado desde',
    'Closed to': 'Cerrado hasta',
    'To Date': 'Fecha hasta',
    'Open Tickets': 'Tickets abiertos',
    'Active complaints': 'Reclamos activos',
    'Close Tickets': 'Tickets cerrados',
    'Resolved complaints': 'Reclamos resueltos',
    'Pending Tickets': 'Tickets pendientes',
    'Awaiting response': 'En espera de respuesta',
    'Avg Resolution Time': 'Tiempo promedio de resolución',
    'Time to close': 'Tiempo de cierre',
    'Ticket Trend': 'Tendencia de tickets',
    'Week starting': 'Semana iniciando',
    'Opened': 'Abiertos',
    'Closed': 'Cerrados',
    'Stats by Team': 'Estadísticas por equipo',
    'Stats by Route': 'Estadísticas por ruta',
    'Average Response Time by Team (hours)': 'Tiempo promedio de respuesta por equipo (horas)',
    'Average Response Time (hours)': 'Tiempo promedio de respuesta (horas)',
    'Average Response Time To Close Ticket By Team': 'Tiempo promedio para cerrar ticket por equipo',
    'Average Response Time To Close Ticket Per User': 'Tiempo promedio para cerrar ticket por usuario',
    'Number of Complaints': 'Número de reclamos',
    'Hours': 'Horas',
    'Incident Reports Categorized By Vending Machine': 'Reportes de incidentes categorizados por máquina vending',
    'No incident reports found.': 'No se encontraron reportes de incidentes.',
    'Machine Location': 'Ubicación de la máquina',
    'Machine ID': 'ID de máquina',
    'Incidents': 'Incidentes',
    'Support Complaints Per Machine': 'Reclamos de soporte por máquina',
    'No support complaints found.': 'No se encontraron reclamos de soporte.',
    'Open Complaints': 'Reclamos abiertos',
    'Call History': 'Historial de llamadas',
    'Closed Complaints': 'Reclamos cerrados',
    'Total Complaints': 'Total de reclamos',
    'Unknown User': 'Usuario desconocido',
    'Unknown Team': 'Equipo desconocido',
    'No Role': 'Sin rol',
    'Stable': 'Estable',
    'Support': 'Soporte',
    'Status': 'Estado',
    'User Management': 'Gestión de usuarios',
    'Teams Management': 'Gestión de equipos',
    'Machine Management': 'Gestión de máquinas',
    'Repair Orders': 'Órdenes de reparación',
    'Technical transfer context': 'Contexto de transferencia técnica',
    'Sent by Customer Support': 'Enviado por Customer Support',
    'Created automatically from WhatsApp': 'Creado automáticamente desde WhatsApp',
    'Assignment status': 'Estado de asignación',
    'Transfer reason': 'Motivo de transferencia',
    'Sent by': 'Enviado por',
    'Sent at': 'Enviado el',
    'Machine Movements': 'Movimientos de máquinas',
    'Preventive Maintenance': 'Mantenimiento preventivo',
    'Parts Inventory': 'Inventario de repuestos',
    'Question Management': 'Gestión de preguntas',
    'Complain Management': 'Gestión de reclamos',
    'Refund Queue': 'Cola de reembolsos',
    'Close Complaints': 'Reclamos cerrados',
    'System Users': 'Usuarios del sistema',
    'Add User': 'Agregar usuario',
    'Edit User': 'Editar usuario',
    'View User': 'Ver usuario',
    'Add a new user': 'Agregar un nuevo usuario',
    'First Name': 'Nombre',
    'Last Name': 'Apellido',
    'Email': 'Correo electrónico',
    'Phone': 'Teléfono',
    'Role': 'Rol',
    'Inactive': 'Inactivo',
    'Enter First Name': 'Ingresar nombre',
    'Enter Last Name': 'Ingresar apellido',
    'Enter Email': 'Ingresar correo electrónico',
    'Enter Phone': 'Ingresar teléfono',
    'Enter Password': 'Ingresar contraseña',
    'Select Role': 'Seleccionar rol',
    'Invalid email': 'Correo electrónico inválido',
    'Email is too long': 'El correo electrónico es demasiado largo',
    'Role is required': 'El rol es obligatorio',
    'Team is required for non-admin roles': 'El equipo es obligatorio para roles que no son admin',
    'Password': 'Contraseña',
    'Password must be at least 8 characters long': 'La contraseña debe tener al menos 8 caracteres',
    'Password must contain at least one uppercase letter': 'La contraseña debe contener al menos una letra mayúscula',
    'Password must contain at least one lowercase letter': 'La contraseña debe contener al menos una letra minúscula',
    'Password must contain at least one number': 'La contraseña debe contener al menos un número',
    'Password must contain at least one special character': 'La contraseña debe contener al menos un carácter especial',
    'Leading and trailing spaces are not allowed': 'No se permiten espacios al inicio ni al final',
    'Phone number should only contain numbers': 'El teléfono solo debe contener números',
    'Add Team': 'Agregar equipo',
    'Edit Team': 'Editar equipo',
    'View Team': 'Ver equipo',
    'Team Name': 'Nombre del equipo',
    'Enter Team Name': 'Ingresar nombre del equipo',
    'Team Lead': 'Líder del equipo',
    'Team Members': 'Miembros del equipo',
    'Lead': 'Líder',
    'Select Team Lead': 'Seleccionar líder del equipo',
    'Select Team Members': 'Seleccionar miembros del equipo',
    'No team members found.': 'No se encontraron miembros del equipo.',
    'Team name is required': 'El nombre del equipo es obligatorio',
    'Team lead is required': 'El líder del equipo es obligatorio',
    'Select at least one member': 'Selecciona al menos un miembro',
    '{0} members selected': '{0} miembros seleccionados',
    'Select multiple users to add them to the team. You can remove members by deselecting them.': 'Selecciona varios usuarios para agregarlos al equipo. Puedes eliminar miembros deseleccionándolos.',
    'Confirm Status Change': 'Confirmar cambio de estado',
    'Are you sure you want to': '¿Seguro que quieres',
    'this item?': 'este registro?',
    'Analytics & Reports': 'Analítica y reportes',
    'OKR': 'OKR',
    'Objectives': 'Objetivos',
    'Objective': 'Objetivo',
    'Key Result': 'Resultado clave',
    'Owner': 'Responsable',
    'Progress': 'Avance',
    'Parlevel': 'Parlevel',
    'Route Planning': 'Planificación de rutas',
    'Parlevel data ingestion and monitoring': 'Ingesta de datos y monitoreo de Parlevel',
    'Overview': 'Resumen',
    'Data & Sync': 'Datos y sincronización',
    'Coin Tubes': 'Tubos de monedas',
    'Coin tubes': 'Tubos de monedas',
    'Change Availability': 'Disponibilidad de cambio',
    'Change availability by machine and route': 'Disponibilidad de cambio por máquina y ruta',
    'View Coin Tubes': 'Ver tubos de monedas',
    'Refresh Coin Tubes': 'Actualizar tubos de monedas',
    'Reporting': 'Reportando',
    'Total machines': 'Máquinas totales',
    'Coin attention': 'Atención de monedas',
    'Among reporting machines': 'Entre máquinas con datos',
    'Readiness': 'Preparación',
    'Action required only': 'Solo requiere atención',
    'All reporting machines': 'Todas las máquinas con datos',
    'No filtered records to export': 'No hay registros filtrados para exportar',
    'records exported': 'registros exportados',
    'Reading source': 'Fuente de lectura',
    'Stale': 'Desactualizado',
    'Data issue': 'Problema de datos',
    'Change float': 'Fondo de cambio',
    'No tube data': 'Sin datos de tubos',
    'All coin tube statuses': 'Todos los estados de tubos',
    'Current reading': 'Lectura actual',
    'Last reported': 'Último reporte',
    'Normalized from': 'Normalizado desde',
    'current reading': 'lectura actual',
    'last reported reading': 'último reporte',
    'Quality': 'Calidad',
    'Unknown denomination': 'Denominación desconocida',
    'Data notes': 'Notas de datos',
    'Total value': 'Valor total',
    'Tubes': 'Tubos',
    'Freshness': 'Actualización',
    'Route readiness': 'Preparación por ruta',
    'Valid and sufficiently funded': 'Datos válidos y cambio suficiente',
    'machines checked': 'máquinas revisadas',
    'without tube data': 'sin datos de tubos',
    'machines reporting coin tube data': 'máquinas reportando datos de tubos',
    'No coin tube records found': 'No se encontraron registros de tubos',
    'Retrieve fresh coin tube levels for all connected Parlevel machines?': '¿Obtener niveles nuevos de tubos para todas las máquinas conectadas en Parlevel?',
    'Coin tube levels updated': 'Niveles de tubos actualizados',
    'Failed to load coin tube data': 'No se pudieron cargar los datos de tubos',
    'Coin observations': 'Observaciones de monedas',
    'Observation mode': 'Modo de observación',
    'Needs review': 'Por revisar',
    'Monitoring': 'Monitoreando',
    'Persistent zero': 'Cero persistente',
    'Explained or suppressed': 'Explicadas o descartadas',
    'Evaluated': 'Evaluadas',
    'View observations': 'Ver observaciones',
    'Hide observations': 'Ocultar observaciones',
    'All observations': 'Todas las observaciones',
    'observations': 'observaciones',
    'Decrease': 'Disminución',
    'Changed reading': 'Lectura con cambio',
    'Evidence': 'Evidencia',
    'No observations match this filter': 'No hay observaciones que coincidan con este filtro',
    'A coin observation does not prove coin removal or operator responsibility.': 'Una observación no demuestra retiro de monedas ni responsabilidad del operador.',
    'Automatic alerts are disabled.': 'Las alertas automáticas están desactivadas.',
    'Registered service': 'Servicio registrado',
    'Cash sale': 'Venta en efectivo',
    'Syncro technical activity': 'Actividad técnica de Syncro',
    'Technical ticket closed': 'Ticket técnico cerrado',
    'Technician assigned': 'Técnico asignado',
    'Syncro ticket': 'Ticket de Syncro',
    'Syncro records the ticket as closed at this time; it does not confirm the time of a physical visit.': 'Syncro registra el cierre del ticket a esta hora; no confirma la hora de una visita física.',
    'Assignment in Syncro; physical visit not confirmed.': 'Asignación en Syncro; visita física no confirmada.',
    'Operator or technician': 'Operador o técnico',
    'All operators and technicians': 'Todos los operadores y técnicos',
    'Hourly association': 'Asociación por hora',
    'Exact association': 'Asociación exacta',
    'The sale does not confirm how the coin tubes changed.': 'La venta no confirma cómo cambiaron los tubos de monedas.',
    'DEX and cash sales history': 'Historial DEX y ventas en efectivo',
    'Cash sales associated with each DEX report in the selected period': 'Ventas en efectivo asociadas a cada reporte DEX del período seleccionado',
    'Cash sales associated': 'Ventas en efectivo asociadas',
    'No cash sale': 'Sin venta en efectivo',
    'Sales data not associated': 'Datos de venta no asociados',
    'Ambiguous sales data': 'Datos de venta ambiguos',
    'Loading machine history': 'Cargando historial de la máquina',
    'Could not load machine history': 'No se pudo cargar el historial de la máquina',
    'No DEX readings were found for this period': 'No se encontraron lecturas DEX para este período',
    'Open the machine to load its DEX history': 'Abra la máquina para cargar su historial DEX',
    'Service near decrease': 'Servicio cercano a la disminución',
    'A registered service is timing context and does not explain a decrease in change tubes.': 'Un servicio registrado es contexto temporal y no explica una disminución en los tubos de cambio.',
    'Operational context': 'Contexto operativo',
    'Operational record near decrease': 'Registro operativo cercano a la disminución',
    'A route service or consolidation record is context for review and does not explain a decrease in change tubes.': 'Un servicio de ruta o registro de consolidación es contexto para revisión y no explica una disminución en los tubos de cambio.',
    'Documented collection': 'Recolección de caja documentada',
    'Cashbox collection context': 'Contexto de recolección de caja',
    'Reported coin collection': 'Recolección de monedas reportada',
    'Reported coin collection amount': 'Monto de monedas reportado como recolectado',
    'Reported coin collection record': 'Registro de recolección de monedas reportada',
    'Reported coin collection — requires review': 'Recolección de monedas reportada — requiere revisión',
    'A reported coin collection does not explain a decrease in change tubes and requires review.': 'Una recolección de monedas reportada no explica una disminución en los tubos de cambio y requiere revisión.',
    'A cashbox collection record is available as context, but it does not explain a decrease in change tubes.': 'Existe un registro de recolección de caja como contexto, pero no explica una disminución en los tubos de cambio.',
    'Telemetry recovered': 'Telemetría recuperada',
    'Data quality': 'Calidad de datos',
    'Wide interval': 'Intervalo amplio',
    'No matching documented collection or telemetry explanation was found. Service is context for review, not a justification by itself.': 'No se encontró una recolección documentada compatible ni una explicación de telemetría. El servicio es contexto para revisar, no una justificación por sí solo.',
    'No verified change payout or telemetry explanation was found. Service and cashbox collection are context for review, not justification.': 'No se encontró una entrega de cambio verificada ni una explicación de telemetría. El servicio y la recolección de caja son contexto para revisar, no una justificación.',
    'A documented collection amount and an exact service time match the balance decrease.': 'El monto de una recolección documentada y la hora exacta de servicio coinciden con la disminución del saldo.',
    'A zero reading is waiting for another report or operational evidence.': 'Una lectura en cero está esperando otro reporte o evidencia operativa.',
    'A registered service time falls inside the balance-change interval.': 'La hora de un servicio registrado está dentro del intervalo del cambio de saldo.',
    'A route service or consolidation record exists on the same Panama date.': 'Existe un servicio de ruta o registro de consolidación en la misma fecha de Panamá.',
    'The balance recovered to at least 95% within three subsequent reports or 48 hours, which indicates a temporary reading.': 'El saldo se recuperó al menos al 95% dentro de los siguientes tres reportes o 48 horas, lo que indica una lectura temporal.',
    'At least two subsequent reports remain at zero. Treat this as a reporting or machine-data issue until operational evidence is available.': 'Al menos dos reportes posteriores permanecen en cero. Trátelo como un problema de reporte o de datos de la máquina hasta contar con evidencia operativa.',
    'The source reading contains a quality warning and is suppressed from review.': 'La lectura de origen contiene una advertencia de calidad y se descarta de la revisión.',
    'The interval between readings is too wide for reliable event timing.': 'El intervalo entre lecturas es demasiado amplio para ubicar el evento con precisión.',
    'Balance before': 'Saldo anterior',
    'Balance after': 'Saldo posterior',
    'Reading interval': 'Intervalo de lecturas',
    'Panama time': 'Hora de Panamá',
    'Timeline': 'Línea de tiempo',
    'Detailed timeline': 'Línea de tiempo detallada',
    '24 hours before and 48 hours after the changed reading': '24 horas antes y 48 horas después de la lectura con cambio',
    'Coin balance': 'Saldo de monedas',
    'Reading': 'Lectura',
    'Loading detailed history': 'Cargando historial detallado',
    'Could not load the detailed history': 'No se pudo cargar el historial detallado',
    'Try again': 'Intentar de nuevo',
    'No detailed readings were found in this time window': 'No se encontraron lecturas detalladas en esta ventana de tiempo',
    'Open the observation to load its detailed history': 'Abra la observación para cargar su historial detallado',
    'Date and time': 'Fecha y hora',
    'Event': 'Evento',
    'Variation': 'Variación',
    'Tubes and changes': 'Tubos y cambios',
    'Tube changes': 'Cambios por tubo',
    'Quality warning': 'Advertencia de calidad',
    'Key observation points': 'Puntos clave de la observación',
    'Balance decreases': 'Disminuciones generales',
    'After service': 'Después de servicio',
    'Post-service rule': 'Regla posterior al servicio',
    'any decrease': 'cualquier disminución',
    'first report': 'primer reporte',
    'First report': 'Primer reporte',
    'First report after service': 'Primer reporte después del servicio',
    'Services evaluated': 'Servicios evaluados',
    'decreases found': 'disminuciones encontradas',
    'Telemetry or monitoring': 'Telemetría o monitoreo',
    'Information pending': 'Información pendiente',
    'The service is recent and its consolidation data is not available yet.': 'El servicio es reciente y sus datos de consolidación todavía no están disponibles.',
    'Consolidation pending': 'Consolidación pendiente',
    'No matching documented collection': 'Sin recolección de caja compatible',
    'No verified change payout data': 'Sin datos verificados de entrega de cambio',
    'Operator and action': 'Operador y acción',
    'A decrease after service is a temporal correlation, not proof of coin removal or operator responsibility.': 'Una disminución después del servicio es una correlación temporal, no demuestra retiro de monedas ni responsabilidad del operador.',
    'Failed to load post-service observations': 'No se pudieron cargar las observaciones posteriores al servicio',
    'Failed to load coin observations': 'No se pudieron cargar las observaciones de monedas',
    'Last 90 days': 'Últimos 90 días',
    'Custom range': 'Rango personalizado',
    'Date range': 'Rango de fechas',
    'Maximum observation range is 93 days.': 'El rango máximo de observación es de 93 días.',
    'Select up to 93 days. Historical telemetry is shown only where Parlevel readings are available.': 'Seleccione hasta 93 días. La telemetría histórica se muestra únicamente donde existen lecturas disponibles en Parlevel.',
    'This date range updates every section on the page. Select up to 93 days.': 'Este rango de fechas actualiza todas las secciones de la página. Seleccione hasta 93 días.',
    'Operational summary': 'Resumen operativo',
    'Snapshot at the end of the selected period': 'Estado al final del período seleccionado',
    'Hide summary': 'Ocultar resumen',
    'View summary': 'Ver resumen',
    'Change float evolution': 'Evolución del fondo de cambio',
    'Fleet-adjusted balance, reporting coverage, installations and removals': 'Saldo ajustado por flota, cobertura de reportes, instalaciones y retiros',
    'Hide trend': 'Ocultar evolución',
    'View trend': 'Ver evolución',
    'Comparable fleet': 'Flota comparable',
    'Reported total': 'Total reportado',
    'Average per reporting machine': 'Promedio por máquina reportando',
    'Reporting machines': 'Máquinas reportando',
    'Comparable machines': 'Máquinas comparables',
    'Installed machines': 'Máquinas instaladas',
    'Confirmed': 'Confirmadas',
    'Removed or persistently absent': 'Retiradas o ausentes de forma persistente',
    'Temporarily missing': 'Ausentes temporalmente',
    'Installed balance entering the fleet': 'Saldo instalado que entra a la flota',
    'Last balance of removed or persistently absent machines': 'Último saldo de máquinas retiradas o ausentes de forma persistente',
    'Historical coverage': 'Cobertura histórica',
    'Comparable fleet includes machines reporting at both ends of the selected period. Inventory changes do not automatically become coin-loss observations.': 'La flota comparable incluye máquinas que reportan en ambos extremos del período seleccionado. Los cambios de inventario no se convierten automáticamente en observaciones de pérdida de monedas.',
    'No historical coin balance readings are available for this period.': 'No hay lecturas históricas del saldo de monedas disponibles para este período.',
    'Machine coin availability': 'Disponibilidad de monedas por máquina',
    'Latest reading within the selected period': 'Última lectura dentro del período seleccionado',
    'Hide machines': 'Ocultar máquinas',
    'View machines': 'Ver máquinas',
    'Route preparation at the end of the selected period': 'Preparación por ruta al final del período seleccionado',
    'Hide routes': 'Ocultar rutas',
    'View routes': 'Ver rutas',
    'Export current filtered observations to Excel': 'Exportar a Excel las observaciones del filtro actual',
    'Asset': 'Activo',
    'Service date and time': 'Fecha y hora del servicio',
    'First report date and time': 'Fecha y hora del primer reporte',
    'Minutes after service': 'Minutos después del servicio',
    'Decrease percent': 'Porcentaje de disminución',
    'Coins before': 'Monedas anteriores',
    'Coins after': 'Monedas posteriores',
    'Coin decrease': 'Disminución de monedas',
    'Tube levels after': 'Niveles posteriores por tubo',
    'Documented collection amount': 'Monto de recolección de caja',
    'Cashbox collection amount': 'Monto de recolección de caja',
    'Consolidation transaction': 'Transacción de consolidación',
    'Recovered': 'Recuperada',
    'Recovery date and time': 'Fecha y hora de recuperación',
    'Recovery balance': 'Saldo recuperado',
    'Quality issues': 'Problemas de calidad',
    'Reason codes': 'Motivos',
    'Observation ID': 'ID de observación',
    'Interpretation': 'Interpretación',
    'Operator attribution': 'Atribución al operador',
    'Not inferred automatically': 'No inferida automáticamente',
    'Previous reading': 'Lectura anterior',
    'Recovery reading': 'Lectura recuperada',
    'Operational evidence': 'Evidencia operativa',
    'No registered service in the interval': 'No hay un servicio registrado dentro del intervalo',
    'Collected coins': 'Monedas recolectadas',
    'Exact service time': 'Hora exacta de servicio',
    'Same-day operational record': 'Registro operativo del mismo día',
    'Matching documented collection': 'Recolección de caja coincidente',
    'Cashbox collection coincidence (context only)': 'Coincidencia con recolección de caja (solo contexto)',
    'Recovered on subsequent report': 'Se recuperó en un reporte posterior',
    'Source quality warning': 'Advertencia de calidad de origen',
    'No operational evidence': 'Sin evidencia operativa',
    'Reconciliation': 'Conciliación',
    'Reconciliation detail': 'Detalle de conciliación',
    'Reconciled': 'Conciliado',
    'Partially reconciled': 'Conciliado parcialmente',
    'Unexplained': 'Sin explicación',
    'Explained by verified change payout': 'Explicada por entrega de cambio verificada',
    'Partially explained by verified change payout': 'Explicada parcialmente por entrega de cambio verificada',
    'Unexplained tube decrease': 'Disminución de tubos sin explicación',
    'Insufficient data': 'Datos insuficientes',
    'A documented collection amount matches the decrease.': 'El monto de una recolección documentada coincide con la disminución.',
    'Operational or telemetry context exists, but the exact cash cause is not documented.': 'Existe contexto operativo o de telemetría, pero la causa exacta del efectivo no está documentada.',
    'No matching collection, service context, or telemetry recovery explains the decrease.': 'Ninguna recolección compatible, contexto de servicio o recuperación de telemetría explica la disminución.',
    'Source quality or timing prevents a reliable reconciliation.': 'La calidad de origen o el intervalo impiden una conciliación confiable.',
    'Verified change-dispensing data explains the tube decrease within tolerance.': 'Los datos verificados de entrega de cambio explican la disminución de los tubos dentro de la tolerancia.',
    'Verified change-dispensing data explains only part of the tube decrease.': 'Los datos verificados de entrega de cambio explican solo una parte de la disminución de los tubos.',
    'The balance recovered on subsequent telemetry, indicating a temporary reading.': 'El saldo se recuperó en la telemetría posterior, lo que indica una lectura temporal.',
    'No verified change-dispensing data explains the tube decrease. Service and cashbox collection records are context only.': 'No hay datos verificados de entrega de cambio que expliquen la disminución de los tubos. El servicio y la recolección de caja son solo contexto.',
    'Interval reconciliation': 'Conciliación del intervalo',
    'This summarizes available evidence; it does not identify transaction order or responsibility.': 'Este resumen presenta la evidencia disponible; no identifica el orden de las transacciones ni atribuye responsabilidad.',
    'Coin fund variation': 'Variación del fondo de monedas',
    'Net coin count': 'Cambio neto de monedas',
    'Net tube variation': 'Variación neta de tubos',
    'No tube changes reported': 'No se reportaron cambios por tubo',
    'Not found': 'No encontrada',
    'Evidence completeness': 'Disponibilidad de evidencia',
    'Coin readings': 'Lecturas de monedas',
    'Tube denominations': 'Denominaciones por tubo',
    'Exact service record': 'Registro exacto de servicio',
    'Consolidation record': 'Registro de consolidación',
    'Matching collection': 'Recolección coincidente',
    'Cashbox collection record': 'Registro de recolección de caja',
    'Verified change payout': 'Entrega de cambio verificada',
    'Verified change dispensed': 'Cambio entregado verificado',
    'Unexplained residual': 'Saldo sin explicación',
    'Explained percent': 'Porcentaje explicado',
    'Not available': 'No disponible',
    'This does not explain a decrease in change tubes.': 'Esto no explica una disminución en los tubos de cambio.',
    'This does not explain a decrease in change tubes and requires review.': 'Esto no explica una disminución en los tubos de cambio y requiere revisión.',
    'Drops after service': 'Disminuciones después de servicio',
    'Subsequent telemetry': 'Telemetría posterior',
    'Cash event sequence': 'Secuencia de eventos de efectivo',
    'Parlevel snapshots do not provide the exact order of accepted cash and returned change.': 'Las lecturas de Parlevel no muestran el orden exacto del efectivo aceptado y el cambio devuelto.',
    'All reconciliation statuses': 'Todos los estados de conciliación',
    'Evidence type': 'Tipo de evidencia',
    'All evidence': 'Toda la evidencia',
    'Minimum decrease': 'Disminución mínima',
    'Any decrease': 'Cualquier disminución',
    'Management priority shows unexplained observations first, then the largest decreases.': 'La prioridad gerencial muestra primero las observaciones sin explicación y luego las mayores disminuciones.',
    'Service time inside balance interval': 'Hora de servicio dentro del intervalo de saldo',
    'Service on the same Panama date': 'Servicio en la misma fecha de Panamá',
    'Consolidation on the same Panama date': 'Consolidación en la misma fecha de Panamá',
    'Documented collection matches decrease': 'El monto de la recolección de caja coincide con la disminución',
    'Cashbox collection amount coincides with decrease': 'El monto de la recolección de caja coincide con la disminución',
    'Reported coin collection coincides with decrease': 'La recolección de monedas reportada coincide con la disminución',
    'Balance recovered on a subsequent report': 'El saldo se recuperó en un reporte posterior',
    'Zero balance reading': 'Lectura de saldo en cero',
    'At least two subsequent zero reports': 'Al menos dos reportes posteriores en cero',
    'Source data quality issue': 'Problema de calidad en los datos de origen',
    'Observation interval too wide': 'Intervalo de observación demasiado amplio',
    'Telemetry recovery rule': 'Regla de recuperación de telemetría',
    'next three reports': 'siguientes tres reportes',
    'Machine, location, route, asset or ID': 'Máquina, ubicación, ruta, activo o ID',
    'each': 'cada una',
    'coins': 'monedas',
    'Last Morning Run': 'Ultima corrida matutina',
    'Last Nightly Run': 'Ultima corrida nocturna',
    'Collection Counts': 'Conteo de colecciones',
    'Manual Run': 'Corrida manual',
    'Run Morning Scrape': 'Ejecutar scrape matutino',
    'Run Nightly Scrape': 'Ejecutar scrape nocturno',
    'Refresh Status': 'Actualizar estado',
    'Recent Scrape Logs': 'Registros de scrape recientes',
    'Data Explorer': 'Explorador de datos',
    'Daily Routes': 'Rutas diarias',
    'Route Sales': 'Ventas por ruta',
    'Consolidation': 'Consolidacion',
    'Machine Inventory': 'Inventario de maquinas',
    'POS Sales': 'Ventas POS',
    'Collection Stats': 'Estadisticas de recoleccion',
    'No logs found': 'No se encontraron registros',
    'No data found': 'No se encontraron datos',
    'No data': 'Sin datos',
    'Task': 'Tarea',
    'Started': 'Iniciado',
    'Finished': 'Finalizado',
    'Duration': 'Duracion',
    'Records': 'Registros',
    'Rows': 'Filas',
    'Refresh': 'Actualizar',
    'This will start a morning scrape. Continue?': 'Esto iniciara un scrape matutino. Continuar?',
    'Confirm Morning Run': 'Confirmar corrida matutina',
    'Morning run started': 'Corrida matutina iniciada',
    'Morning run failed': 'Corrida matutina fallida',
    'This will start a full nightly scrape. This may take several minutes. Continue?': 'Esto iniciara un scrape nocturno completo. Puede tomar varios minutos. Continuar?',
    'Confirm Nightly Run': 'Confirmar corrida nocturna',
    'Nightly run started': 'Corrida nocturna iniciada',
    'Nightly run failed': 'Corrida nocturna fallida',
    'Parlevel Dashboard': 'Panel Parlevel',
    'Operations monitoring and analytics': 'Monitoreo de operaciones y analítica',
    'Operator Dashboard': 'Dashboard de Operadores',
    'Operator dashboard title': 'Dashboard',
    'My Operational Dashboard': 'Mi Dashboard Operativo',
    'Operator': 'Operador',
    'Select an operator': 'Seleccione un operador',
    'Select operator': 'Seleccionar operador',
    'Select an operator to continue.': 'Selecciona un operador para continuar.',
    'All my routes': 'Todas mis rutas',
    'All operator routes': 'Todas las rutas del operador',
    'Assigned routes': 'Rutas asignadas',
    'No assigned routes': 'Sin rutas asignadas',
    'My OKR': 'Mis OKR',
    'Operator OKR': 'OKR del operador',
    'Operations OKR': 'OKR de la operación',
    'Weekly OKR results': 'Resultados semanales',
    'Weekly progress': 'Progreso semanal',
    'Cycle progress': 'Progreso del trimestre',
    'Cycle trend': 'Resultados del trimestre',
    'Points achieved': 'Puntos logrados',
    'Points achieved compared with the weekly target': 'Puntos logrados comparados con la meta semanal',
    'Points': 'Puntos',
    'Future week': 'Semana futura',
    'No historical OKR points are available for this cycle.': 'No hay puntos OKR históricos disponibles para este ciclo.',
    'OKR details': 'Detalles de OKR',
    'Send update': 'Enviar actualización',
    'Weekly update sent.': 'Actualización semanal enviada.',
    'Could not send the weekly update.': 'No se pudo enviar la actualización semanal.',
    'OKR updates to send': 'OKR por enviar',
    'No permission': 'Sin permiso',
    'Locked week': 'Semana bloqueada',
    'Available after the week closes': 'Disponible al cerrar la semana',
    'No weekly record': 'Sin registro semanal',
    'Weekly update has not been sent.': 'La actualización semanal aún no se ha enviado.',
    'Weekly update is pending approval.': 'La actualización semanal está pendiente de aprobación.',
    'Weekly update was approved.': 'La actualización semanal fue aprobada.',
    'Weekly update was rejected.': 'La actualización semanal fue rechazada.',
    'OKR week': 'Semana OKR',
    'Current week': 'Semana actual',
    'Loading OKR results': 'Cargando resultados OKR',
    'Select an operator to view their weekly OKR results.': 'Selecciona un operador para ver sus resultados OKR de la semana.',
    'Operations OKR context is not available.': 'El contexto OKR de Operaciones no está disponible.',
    'Could not load OKR weekly results.': 'No se pudieron cargar los resultados OKR semanales.',
    'Collaborator': 'Colaborador',
    'Cycle': 'Ciclo',
    'Weekly earned points': 'Puntos logrados esta semana',
    'Weekly target': 'Meta semanal',
    'Weekly achievement': 'Cumplimiento semanal',
    'Cycle accumulated': 'Acumulado del ciclo',
    'Assigned points progress': 'Progreso frente a puntos asignados',
    'Measurement': 'Medición',
    'Calculation details': 'Detalles del cálculo',
    'Calculation details are not available for this week.': 'Los detalles del cálculo no están disponibles para esta semana.',
    'Weight': 'Peso',
    'Expected weekly points': 'Puntos esperados por semana',
    'Operator dashboard period': 'Período',
    'Last update': 'Última actualización',
    'Operator dashboard from': 'Desde',
    'Operator dashboard to': 'Hasta',
    'Operator dashboard update': 'Actualizar',
    'Loading routes': 'Cargando rutas',
    'Loading summary': 'Cargando resumen',
    'Everything is up to date': 'Todo al día',
    'Selected week': 'Semana seleccionada',
    'Scheduled': 'Programadas',
    'Serviced': 'Atendidas',
    'Services today': 'Servicios de hoy',
    'Completed services': 'Completados',
    'Pending today': 'Pendientes hoy',
    'Today is still in progress; pending services are not anomalies.': 'El día sigue en curso; los servicios pendientes todavía no son anomalías.',
    'Consolidated through': 'Consolidado hasta',
    'Unjustified anomalies': 'Anomalías sin justificar',
    'Select a route to continue.': 'Selecciona una ruta para continuar.',
    'From date cannot be after to date.': 'La fecha desde no puede ser posterior a la fecha hasta.',
    'You do not have assigned routes. Contact an administrator.': 'No tienes rutas asignadas. Contacta a un administrador.',
    'You do not have access to this module.': 'No tienes acceso a este módulo.',
    'You do not have access to this route.': 'No tienes acceso a esta ruta.',
    'Could not load operator dashboard routes.': 'No se pudieron cargar las rutas del dashboard de operadores.',
    'Could not load operator dashboard summary.': 'No se pudo cargar el resumen del dashboard de operadores.',
    'No operational data was found for this route and period.': 'No se encontraron datos operativos para esta ruta y período.',
    'No operational data was found for this operator and period.': 'No se encontraron datos operativos para este operador y período.',
    'No actual Parlevel service records were found for this driver and period.': 'Parlevel no tiene servicios actual registrados para este conductor y período.',
    'The operational period was adjusted manually and no longer matches the selected OKR week.': 'El período operativo fue ajustado manualmente y ya no coincide con la Semana OKR seleccionada.',
    'Route execution': 'Ejecución de ruta',
    'Operator operation': 'Resumen operativo',
    'You do not have access to this operator dashboard.': 'No tienes acceso a este dashboard de operador.',
    'Scheduled machines': 'Programadas',
    'Serviced machines': 'Atendidas',
    'Unserviced machines KPI': 'No atendidas',
    'Completed maintenance': 'Mantenimiento Preventivo',
    'Open machine tickets': 'Tickets abiertos por máquina',
    'OKR 3 reference only': 'Referencia para OKR 3; no modifica puntos oficiales.',
    'Open tickets': 'Tickets abiertos',
    'Machines with open tickets': 'Máquinas con tickets abiertos',
    'Unassigned tickets': 'Tickets sin asignar',
    'Oldest ticket age': 'Ticket más antiguo',
    'No open machine tickets were found for this operator period.': 'No se encontraron tickets abiertos para este operador y período.',
    'Tickets included in OKR 3': 'Tickets incluidos en OKR 3',
    'OKR 3 source details': 'Detalle oficial de la fuente de OKR 3.',
    'Source details': 'Detalle de la fuente',
    'Items included': 'Registros incluidos',
    'Actual value': 'Valor obtenido',
    'Calculated points': 'Puntos calculados',
    'Final points': 'Puntos finales',
    'Machines ready for installation': 'Máquinas habilitadas para instalación',
    'Open cases': 'Casos abiertos',
    'Closed cases': 'Casos cerrados',
    'Average repair time': 'Tiempo promedio de reparación',
    'Route compliance': 'Cumplimiento de ruta',
    'Avg. Par Level': 'Porcentaje de llenado',
    'Active routes': 'Rutas activas',
    'Completed preventives': 'Preventivos completados',
    'Routes included': 'Rutas incluidas',
    'Average per route': 'Promedio por ruta',
    'Target per route': 'Meta por ruta',
    'No OKR source details were found for this weekly result.': 'No se encontraron detalles de fuente para este resultado semanal OKR.',
    'Tickets included': 'Tickets incluidos',
    'Assigned machines': 'Máquinas asignadas',
    'Tickets per 10 machines': 'Tickets por cada 10 máquinas',
    'OKR source percentage': 'Porcentaje de fuente OKR',
    'No OKR ticket details were found for this weekly result.': 'No se encontraron detalles de tickets para este resultado semanal OKR.',
    'Created at': 'Fecha de creación',
    'Operator dashboard ticket route': 'Ruta',
    'Opened at': 'Fecha de apertura',
    'Failure detail': 'Detalle de falla',
    'Assigned technician': 'Técnico asignado',
    'Scorecard': 'Scorecard',
    'Formula pending': 'Fórmula pendiente',
    'Scoring formula is pending.': 'La fórmula de puntaje está pendiente.',
    'OKR 1/OKR 2 max scores and targets are known, but the partial scoring formula is not defined yet.': 'Los puntajes máximos y metas de OKR 1/OKR 2 están definidos, pero la fórmula de puntaje parcial todavía no está definida.',
    'KR1/KR2 max scores and targets are known, but the partial scoring formula is not defined yet.': 'Los puntajes máximos y metas de KR1/KR2 están definidos, pero la fórmula de puntaje parcial todavía no está definida.',
    'Operator dashboard score': 'Puntaje',
    'Max score': 'Puntaje máximo',
    'Operator dashboard target': 'Meta',
    'Weeks in period': 'Semanas del período',
    'week': 'semana',
    'Anomalies': 'Anomalías',
    'Unserviced machines': 'Máquinas no atendidas',
    'After hours': 'Fuera de horario',
    'Time gaps': 'Brechas de tiempo',
    'No anomalies were detected in this period.': 'No se detectaron anomalías en este período.',
    'Operator dashboard date': 'Fecha',
    'Operator dashboard machine': 'Máquina',
    'Operator dashboard location': 'Ubicación',
    'Reason/status': 'Motivo/status',
    'Not serviced': 'No atendida',
    'Service time': 'Hora de servicio',
    'From machine': 'Desde máquina',
    'To machine': 'Hacia máquina',
    'Gap duration': 'Duración de la brecha',
    'All statuses': 'Todos los estados',
    'Unjustified': 'Sin justificar',
    'Draft': 'Borrador',
    'Pending approval': 'Pendiente de aprobación',
    'Approved': 'Aprobada',
    'Rejected': 'Rechazada',
    'Justification status': 'Estado de justificación',
    'Justify': 'Justificar',
    'View comment': 'Ver comentario',
    'View justification': 'Ver justificación',
    'Justify anomaly': 'Justificar anomalía',
    'Save and send for approval': 'Guardar y enviar a aprobación',
    'Why did this anomaly happen?': '¿Por qué ocurrió esta anomalía?',
    'Explanation of what happened': 'Explicación de lo ocurrido',
    'Explanation': 'Explicación',
    'Explanation is required to submit.': 'La explicación es obligatoria para enviar.',
    'Save draft': 'Guardar borrador',
    'Submit for approval': 'Enviar para aprobación',
    'History': 'Historial',
    'No history yet.': 'Sin historial todavía.',
    'Could not save anomaly review.': 'No se pudo guardar la justificación.',
    'Pending approvals': 'Aprobaciones pendientes',
    'Anomaly approvals': 'Aprobaciones de anomalías',
    'Operator activity': 'Actividad del operador',
    'Select an operator to view their anomalies.': 'Selecciona un operador para ver sus anomalías.',
    'No pending approvals for this operator.': 'No hay aprobaciones pendientes para este operador.',
    'Selected operator summary': 'Resumen del operador seleccionado',
    'in this period.': 'en este período.',
    'has no unjustified anomalies in this period.': 'no tiene anomalías sin justificar en este período.',
    'Up to date': 'Al día',
    'Returns': 'Devoluciones',
    'Pending returns': 'Devoluciones pendientes',
    'Pending resolutions for machines assigned to this operator': 'Resoluciones pendientes de las máquinas asignadas a este operador',
    'Product deliveries': 'Entregas de producto',
    'Bank refunds': 'Reembolsos bancarios',
    'Cash cases are completed by the operator after delivering the product.': 'Los casos pagados en efectivo los completa el operador después de entregar el producto.',
    'Bank refunds are completed automatically when Finance approves the payment.': 'Los reembolsos bancarios se completan automáticamente cuando Finanzas aprueba el pago.',
    'Loading returns': 'Cargando devoluciones',
    'Could not load returns.': 'No se pudieron cargar las devoluciones.',
    'This operator has no pending returns.': 'Este operador no tiene devoluciones pendientes.',
    'Select an operator to view their pending returns.': 'Selecciona un operador para ver sus devoluciones pendientes.',
    'Bank refund': 'Reembolso bancario',
    'Product delivery': 'Entrega de producto',
    'Preparing refund': 'Preparando reembolso',
    'Pending Finance review': 'Pendiente de revisión de Finanzas',
    'Ready for bank': 'Listo para el banco',
    'Under revision': 'En revisión',
    'Exported to bank file': 'Exportado al archivo bancario',
    'Submitted to bank': 'Enviado al banco',
    'Refund rejected': 'Reembolso rechazado',
    'Pending Finance': 'Pendiente de Finanzas',
    'Pending product delivery': 'Pendiente de entrega de producto',
    'Confirm product delivery': 'Confirmar entrega de producto',
    'Managed by Finance': 'Gestionado por Finanzas',
    'Ticket detail': 'Detalle del ticket',
    'Confirm delivery': 'Confirmar entrega',
    'Confirm only after the product has been delivered. If a refund is pending, the ticket remains open for Finance.': 'Confirma únicamente después de entregar el producto. Si hay un reembolso pendiente, el ticket permanecerá abierto para Finanzas.',
    'Delivery note': 'Nota de entrega',
    'Optional: product delivered, customer contacted, or relevant detail': 'Opcional: producto entregado, cliente contactado o detalle relevante',
    'Could not complete the return.': 'No se pudo completar la devolución.',
    'Cash product return': 'Devolución de producto en efectivo',
    'Product return': 'Devolución de producto',
    'Cash return': 'Devolución en efectivo',
    'Cash returns': 'Devoluciones en efectivo',
    'All cash returns': 'Todas las devoluciones en efectivo',
    'Pending assignment': 'Pendiente de asignación',
    'Ready to assign': 'Lista para asignar',
    'Ready to send': 'Lista para enviar',
    'In progress with operator': 'En gestión por el operador',
    'With operator': 'Con el operador',
    'Requires Customer Service': 'Requiere Atención al Cliente',
    'Assigned operator': 'Operador asignado',
    'No operator assigned to this machine': 'Esta máquina no tiene un operador asignado',
    'Sent': 'Enviada',
    'Operator could not complete the delivery': 'El operador no pudo completar la entrega',
    'Product to deliver': 'Producto que debe entregar',
    'Product name and quantity': 'Nombre del producto y cantidad',
    'Instructions for operator': 'Instrucciones para el operador',
    'Office instructions': 'Instrucciones de oficina',
    'Optional delivery detail': 'Detalle opcional de la entrega',
    'The operator is managing the product delivery. Customer Service keeps this WhatsApp conversation.': 'El operador está gestionando la entrega del producto. Atención al Cliente conserva esta conversación de WhatsApp.',
    'Send to operator': 'Enviar al operador',
    'Send back to operator': 'Volver a enviar al operador',
    'Customer name and product details are required.': 'El nombre del cliente y el detalle del producto son obligatorios.',
    'Product delivered': 'Producto entregado',
    'Could not deliver': 'No pude entregarlo',
    'Return to Customer Service': 'Devolver a Atención al Cliente',
    'Send to Customer Service': 'Enviar a Atención al Cliente',
    'Customer Service will continue the same WhatsApp conversation with the customer.': 'Atención al Cliente continuará la misma conversación de WhatsApp con el cliente.',
    'Why could you not deliver the product?': '¿Por qué no pudo entregar el producto?',
    'Example: customer was not at the location or could not be reached': 'Ejemplo: el cliente no estaba en la ubicación o no pudo ser contactado',
    'Could not return the task to Customer Service.': 'No se pudo devolver la tarea a Atención al Cliente.',
    'has': 'tiene',
    'unjustified anomaly': 'anomalía sin justificar',
    'unjustified anomalies': 'anomalías sin justificar',
    'Loading pending approvals': 'Cargando aprobaciones pendientes',
    'No pending approvals.': 'No hay aprobaciones pendientes.',
    'Anomaly type': 'Tipo de anomalía',
    'Machine or gap': 'Máquina o brecha',
    'Submitted at': 'Fecha de envío',
    'Gap range': 'Rango de brecha',
    'Approve anomaly explanation': 'Aprobar justificación de anomalía',
    'Reject anomaly explanation': 'Rechazar justificación de anomalía',
    'Review comment': 'Comentario de revisión',
    'Review comment required': 'Comentario de revisión obligatorio',
    'Review comment is required to reject.': 'El comentario de revisión es obligatorio para rechazar.',
    'Could not save review decision.': 'No se pudo guardar la decisión.',
    'Can review operator anomalies': 'Puede revisar anomalías de operadores',
    'Shows anomaly approvals tab': 'Muestra la pestaña de aprobaciones de anomalías',
    'Operator routes': 'Rutas del operador',
    'Select operator routes': 'Seleccionar rutas del operador',
    'Operator route is too long': 'La ruta del operador es demasiado larga',
    'Operator routes can include up to 20 routes': 'Las rutas del operador pueden incluir hasta 20 rutas',
    'Changing this user away from operator will clear assigned operator routes. Continue?': 'Cambiar este usuario fuera del rol operator limpiará sus rutas asignadas. ¿Continuar?',
    'Daily': 'Diario',
    'Weekly': 'Semanal',
    'Monthly': 'Mensual',
    'Week containing': 'Semana que contiene',
    'Compare with': 'Comparar con',
    'No data available for this period': 'No hay datos disponibles para este periodo',
    'Total Sales': 'Ventas totales',
    'Period Sales': 'Ventas del período',
    'Cashless': 'Sin efectivo',
    'Machines Serviced': 'Maquinas atendidas',
    'Total Collected': 'Total recolectado',
    'Active Routes': 'Rutas activas',
    'active routes': 'rutas activas',
    'Avg Hours/Route': 'Hrs promedio/Ruta',
    'Unserviced': 'Sin atender',
    'Over/Short': 'Sobrante/Faltante',
    'Short': 'Faltante',
    'Metric': 'Métrica',
    'Change': 'Cambio',
    'Route Compliance': 'Cumplimiento de rutas',
    'Route': 'Ruta',
    'Driver': 'Conductor',
    'Planned': 'Planificado',
    'Actual': 'Real',
    'Compliance': 'Cumplimiento',
    'Sold': 'Vendido',
    'Collected': 'Recolectado',
    'O/S': 'S/F',
    'No route data': 'Sin datos de rutas',
    'Driver Performance': 'Rendimiento de conductores',
    'Transactions': 'Transacciones',
    'Total Refund Amount': 'Monto total a reembolsar',
    'Banco General account number must be exactly 13 digits.': 'El número de cuenta de Banco General debe tener exactamente 13 dígitos.',
    'Refunds': 'Reembolsos',
    'No driver data': 'Sin datos de conductores',
    'Time Gaps': 'Brechas de tiempo',
    'No time gaps detected': 'No se detectaron brechas de tiempo',
    'From': 'Desde',
    'To': 'Hasta',
    'Gap': 'Brecha',
    'From Machine': 'Maquina origen',
    'To Machine': 'Maquina destino',
    'After Hours': 'Fuera de horario',
    'Out of Work Hours': 'Fuera de horario laboral',
    'No after-hours services': 'Sin servicios fuera de horario',
    'Time': 'Hora',
    'Machine': 'Maquina',
    'Location': 'Ubicacion',
    'Compliance Alerts': 'Alertas de cumplimiento',
    'Days Below 90%': 'Dias bajo 90%',
    'Avg Compliance': 'Cumplimiento promedio',
    'Severity': 'Severidad',
    'Critical': 'Critico',
    'Warning': 'Alerta',
    'Daily Detail': 'Detalle diario',
    'Name': 'Nombre',
    'Unserviced Machines': 'Maquinas no atendidas',
    'Optimization Insights': 'Análisis de optimización',
    'Routes Running Late': 'Rutas con retraso frecuente',
    'Days Late': 'Días tarde',
    'Latest': 'Más tarde',
    'Drivers with Most Idle Time': 'Conductores con más tiempo inactivo',
    'Total Gaps': 'Brechas totales',
    'Gaps/Day': 'Brechas/Día',
    'Idle Time': 'Tiempo inactivo',
    'Idle %': '% Inactivo',
    'Frequently Unserviced Machines': 'Máquinas frecuentemente sin atender',
    'Times Missed': 'Veces omitida',
    'Dates': 'Fechas',
    'Filtered view': 'Vista filtrada',
    'Missed': 'Omitidas',
    'After Hrs': 'Fuera horario',
    'Drivers': 'Conductores',
    'Avg Duration': 'Duración prom.',
    'Days': 'Días',
    'Route Efficiency Ranking': 'Ranking de eficiencia de rutas',
    'Score': 'Puntaje',
    'Rating': 'Calificación',
    'Excellent': 'Excelente',
    'Good': 'Bueno',
    'Needs Improvement': 'Necesita mejora',
    '$/Machine': '$/Máquina',
    'Sales by Machine Type': 'Ventas por tipo de máquina',
    'Machine Type': 'Tipo de máquina',
    'Select machine type': 'Seleccionar tipo de máquina',
    'Máquina de Café': 'Máquina de Café',
    'Máquina de Snack': 'Máquina de Snack',
    'Detected machine type:': 'Tipo detectado:',
    'Select categories from the general list because this ticket has no machine type saved.': 'Selecciona categorías de la lista general porque este ticket no tiene tipo de máquina guardado.',
    'Services': 'Servicios',
    'Avg Par %': 'Par % prom.',
    'est. lost': 'pérdida est.',
    'Est. Lost': 'Pérdida est.',
    'Improving': 'Mejorando',
    'Worsening': 'Empeorando',
    'Daily Breakdown': 'Desglose diario',
    'Routes': 'Rutas',
    'Machines': 'Maquinas',
    'Days': 'Dias',
    'Weekly Breakdown': 'Desglose semanal',
    'Week': 'Semana',
    'Date': 'Fecha',
    'Sources': 'Fuentes',
    'Errors': 'Errores',
    'Analytics & Reporting Hub': 'Centro de analítica y reportes',
    'Comprehensive business insights and performance analytics': 'Perspectivas empresariales integrales y analítica de rendimiento',
    'Customer Reports': 'Reportes de clientes',
    'Case Tracking Dashboard': 'Panel de seguimiento de casos',
    'List of Failures': 'Lista de fallas',
    'Incident Report': 'Reporte de incidencias',
    'Performance Reports': 'Reportes de rendimiento',
    'Machine History': 'Historial de máquinas',
    'Technician Performance': 'Rendimiento de técnicos',
    'Failure Analysis': 'Análisis de fallas',
    'Recurrent Failures': 'Fallas recurrentes',
    'Parts Usage': 'Uso de repuestos',
    'Failure ID': 'ID de falla',
    'Service Area': 'Área de servicio',
    'All Cases': 'Todos los casos',
    'No cases found.': 'No se encontraron casos.',
    'No failures found.': 'No se encontraron fallas.',
    'No history found.': 'No se encontró historial.',
    'Date': 'Fecha',
    'Event Type': 'Tipo de evento',
    'Cost': 'Costo',
    'Duration': 'Duración',
    'All Customers': 'Todos los clientes',
    'All Users': 'Todos los usuarios',
    'All Teams': 'Todos los equipos',
    'All Technicians': 'Todos los técnicos',
    'All Statuses': 'Todos los estados',
    'All Locations': 'Todas las ubicaciones',
    'All time': 'Todo el tiempo',
    'Apply Filter': 'Aplicar filtro',
    'Filter by Customer': 'Filtrar por cliente',
    'Select customer': 'Seleccionar cliente',
    'Unknown Customer': 'Cliente desconocido',
    'Filter by Machine ID': 'Filtrar por ID de máquina',
    'Search text across all machines': 'Buscar texto en todas las máquinas',
    'Clear': 'Limpiar',
    'Response Times by Team': 'Tiempos de respuesta por equipo',
    'Average response time metrics grouped by team performance.': 'Métricas de tiempo de respuesta promedio agrupadas por el rendimiento del equipo.',
    'Customer Satisfaction Index': 'Índice de satisfacción del cliente',
    'Average Satisfaction Score': 'Puntaje promedio de satisfacción',
    'Based on': 'Basado en',
    'responses': 'respuestas',
    'Across all teams': 'En todos los equipos',
    'Resolved Cases': 'Casos resueltos',
    'Faults Addressed by Technician': 'Fallas atendidas por técnico',
    'Individual technician performance metrics showing total faults, resolved, and pending cases.': 'Métricas individuales de rendimiento del técnico que muestran fallas totales, resueltas y pendientes.',
    'Total Faults': 'Total de fallas',
    'Failure Analysis Report': 'Reporte de análisis de fallas',
    'Most Common Failure Type': 'Tipo de falla más común',
    'For': 'Para',
    'at': 'en',
    'occurrences': 'ocurrencias',
    'Percentage': 'Porcentaje',
    'Date Range': 'Rango de fechas',
    'No data available.': 'No hay datos disponibles.',
    'Recurrent Failures Summary': 'Resumen de fallas recurrentes',
    'Machines with Recurrent Issues': 'Máquinas con problemas recurrentes',
    'High Priority': 'Prioridad alta',
    'Total Service Calls': 'Total de llamadas de servicio',
    'Machines with Recurrent Failures (>5 service calls in 15 days)': 'Máquinas con fallas recurrentes (>5 llamadas de servicio en 15 días)',
    'No recurrent failures found.': 'No se encontraron fallas recurrentes.',
    'Service Calls': 'Llamadas de servicio',
    'Days Period': 'Período en días',
    'Last Service Date': 'Última fecha de servicio',
    'Common Issues': 'Problemas comunes',
    'Date Range Filter': 'Filtro por rango de fechas',
    'Filters': 'Filtros',
    'Case ID': 'ID del caso',
    'Average Response Time': 'Tiempo promedio de respuesta',
    'Total Cases': 'Total de casos',
    'Last Updated': 'Última actualización',
    'Total Quantity Used': 'Cantidad total usada',
    'Total Cost': 'Costo total',
    'Total Tickets': 'Total de tickets',
    'Parts Usage Report': 'Reporte de uso de repuestos',
    'No parts usage data found.': 'No se encontraron datos de uso de repuestos.',
    'Part Code': 'Código de repuesto',
    'Part Name': 'Nombre del repuesto',
    'Usage Type': 'Tipo de uso',
    'Quantity Used': 'Cantidad usada',
    'Machines Used': 'Máquinas usadas',
    'Last Used': 'Último uso',
    'User': 'Usuario',
    'All Types': 'Todos los tipos',
    'Select Failure Type': 'Seleccionar tipo de falla',
    'Select Service Area': 'Seleccionar área de servicio',
    'Select Machine Type': 'Seleccionar tipo de máquina',
    'Select Location': 'Seleccionar ubicación',
    'Claim SLA (minutes)': 'SLA de toma (minutos)',
    'Mean Time to Repair': 'Tiempo promedio de reparación',
    'Assignment SLA': 'SLA de asignación',
    'Target:': 'Objetivo:',
    'minutes': 'minutos',
    'Claimed Within SLA': 'Tomados dentro del SLA',
    'Avg Time to Claim': 'Tiempo promedio para tomar',
    'Open Unclaimed': 'Abiertos sin tomar',
    'By Route': 'Por ruta',
    'By Team': 'Por equipo',
    'No route data.': 'No hay datos por ruta.',
    'Total': 'Total',
    'Claimed': 'Tomados',
    'Unclaimed Open': 'Abiertos no tomados',
    'Avg Claim': 'Promedio de toma',
    'Within SLA': 'Dentro del SLA',
    'No team data.': 'No hay datos por equipo.',
    'Unclaimed Aging': 'Antigüedad sin tomar',
    'No unclaimed tickets.': 'No hay tickets sin tomar.',
    'Age': 'Antigüedad',
    'Repairs by Failure Type': 'Reparaciones por tipo de falla',
    'No actions recorded': 'No hay acciones registradas',
    'No parts used': 'No se usaron repuestos',
    'Movement Type': 'Tipo de movimiento',
    'Preventive Maintenance Tasks': 'Tareas de mantenimiento preventivo',
    'Awaiting Customer Response': 'En espera de respuesta del cliente',
    'Awaiting Response': 'En espera de respuesta',
    'Resolved': 'Resuelto',
    'Priority': 'Prioridad',
    'Select Customer': 'Seleccionar cliente',
    'Select Technician': 'Seleccionar técnico',
    'Select Status': 'Seleccionar estado',
    'All Refunds': 'Todos los reembolsos',
    'All in Finance': 'Todos en Finanzas',
    'Tickets in Finance': 'reclamos en Finanzas',
    'Refunds in this stage': 'reembolsos en esta etapa',
    'Pending Finance Review': 'Pendiente de revisión de finanzas',
    'Ready for Bank Upload': 'Lista para carga bancaria',
    'Revision': 'Revisión',
    'Exported': 'Exportado',
    'Submitted to Bank': 'Enviado al banco',
    'Refund In Process': 'Reembolso en Proceso',
    'Customer Notified': 'Cliente notificado',
    'refund_in_process': 'reembolso_en_proceso',
    'Search refunds': 'Buscar reembolsos',
    'Export Ready TXT': 'Exportar TXT listos',
    'Select Batch': 'Seleccionar lote',
    'Mark Submitted to Bank': 'Marcar enviado al banco',
    'Approve & Notify Customers': 'Aprobar y notificar clientes',
    'Notify Customers': 'Notificar clientes',
    'Approve all pending': 'Aprobar todas las pendientes',
    'Approve all pending refunds confirmation': '¿Deseas marcar todas las transacciones pendientes como listas para carga bancaria?',
    'Send back to Ready for Bank Upload': 'Regresar a Lista para carga bancaria',
    'Send batch back to ready for bank upload confirmation': '¿Deseas regresar este lote a Lista para carga bancaria? Deberás exportarlo nuevamente.',
    'No refunds found.': 'No se encontraron reembolsos.',
    'Duplicate Warnings': 'Alertas de duplicados',
    'Recurrence': 'Recurrencia',
    'Open complaint': 'Abrir reclamo',
    'Reason for rejection': 'Motivo del rechazo',
    'Already processed': 'Ya procesado',
    'Already processed note': 'Nota de reembolso ya procesado',
    'Refund was previously approved and processed': 'El reembolso fue aprobado y procesado anteriormente',
    'Restore the prior approval without notifying the customer': 'Restaurar la aprobación anterior sin notificar al cliente',
    'Ready': 'Lista',
    'Bank Entity': 'Entidad Bancaria',
    'Amount': 'Monto',
    'Account Type': 'Tipo de cuenta',
    'Account Number': 'Número de cuenta',
    'Batch': 'Lote',
    'Other': 'Otro',
    'Banco General': 'Banco General',
    'Ahorro': 'Ahorro',
    'Corriente': 'Corriente',
    'Select account type': 'Seleccionar tipo de cuenta',
    'Enter Machine ID': 'Ingresar ID de máquina',
    'Supervisor': 'Supervisor',
    'Pending': 'Pendiente',
    'hours': 'horas',
    'Until': 'Hasta',
    'to': 'a',
    'Export': 'Exportar',
    'None': 'Ninguno',
    'Count': 'Cantidad',
    'N/A': 'N/D',
    'Operations & People': 'Operaciones y Personas',
    'Logout': 'Cerrar sesión',
    'Track, manage, and close repair orders for machine maintenance.': 'Monitorea, gestiona y cierra órdenes de reparación para mantenimiento de máquinas.',
    'Create Ticket': 'Crear ticket',
    'Create Follow-up': 'Crear seguimiento',
    'Machine': 'Máquina',
    'Select machine': 'Seleccionar máquina',
    'Technician': 'Técnico',
    'Select technician': 'Seleccionar técnico',
    'Issue Details': 'Detalle del problema',
    'Follow-up Details': 'Detalle del seguimiento',
    'Describe the issue reported by the customer or technician.': 'Describe el problema reportado por el cliente o el técnico.',
    'Describe the follow-up visit.': 'Describe la visita de seguimiento.',
    'Issue Photo': 'Foto del problema',
    'Follow-up Photo': 'Foto del seguimiento',
    'Optional. Upload a photo related to the issue.': 'Opcional. Carga una foto relacionada con el problema.',
    'Cancel': 'Cancelar',
    'Reassign Technician': 'Reasignar técnico',
    'Assign Technician': 'Asignar técnico',
    'Order': 'Orden',
    'Current assignment:': 'Asignación actual:',
    'Update Assignment': 'Actualizar asignación',
    'Close Repair Order': 'Cerrar orden de reparación',
    'Close Follow-up': 'Cerrar seguimiento',
    'Type of Failure': 'Tipo de falla',
    'Select failure type': 'Seleccionar tipo de falla',
    'Failure Category': 'Categoría de falla',
    'Select failure category': 'Seleccionar categoría de falla',
    'Actions Taken': 'Acciones realizadas',
    'Follow-up Notes': 'Notas del seguimiento',
    'Describe the work performed': 'Describe el trabajo realizado',
    'Describe the follow-up visit result': 'Describe el resultado de la visita de seguimiento',
    'Final Status': 'Estado final',
    'Select final status': 'Seleccionar estado final',
    'Repair Photos': 'Fotos de reparación',
    'Follow-up Photos': 'Fotos del seguimiento',
    'Max 500 KB each.': 'Máximo 500 KB cada una.',
    'Max 1.5 MB each.': 'Máximo 1.5 MB cada una.',
    'photo': 'foto',
    'photos': 'fotos',
    'added': 'agregadas',
    'Remove': 'Eliminar',
    'Save & Close': 'Guardar y cerrar',
    'Open': 'Abiertas',
    'Completed': 'Completadas',
    'Total Repair Orders': 'Total de órdenes de reparación',
    'Completed This Month': 'Completadas en el mes',
    'Total Repair Orders This Month': 'Total de órdenes de reparación en el mes',
    'Unassigned Open': 'Abiertas sin asignar',
    'Open Follow-ups': 'Seguimientos abiertos',
    'Completed Follow-ups': 'Seguimientos completados',
    'Weekly Repair Performance': 'Rendimiento semanal de reparaciones',
    'From': 'Desde',
    'To': 'Hasta',
    'Start date': 'Fecha inicial',
    'End Date': 'Fecha final',
    'End date': 'Fecha final',
    'Load Weekly Summary': 'Cargar resumen semanal',
    'Week': 'Semana',
    'Total Repairs': 'Total de reparaciones',
    'Avg Duration': 'Duración promedio',
    'My Tickets': 'Mis tickets',
    'Unassigned': 'Sin asignar',
    'open ticket': 'ticket abierto',
    'open tickets': 'tickets abiertos',
    'Export to Excel': 'Exportar a Excel',
    'Export all open tickets to Excel (respects current date filters)': 'Exportar todos los tickets abiertos a Excel respetando los filtros de fecha.',
    'Filter by Date - From': 'Filtrar por fecha - Desde',
    'Filter by Date - To': 'Filtrar por fecha - Hasta',
    'Filter by Route': 'Filtrar por ruta',
    'All Routes': 'Todas las rutas',
    'Clear Filter': 'Limpiar filtro',
    'No open tickets found.': 'No se encontraron tickets abiertos.',
    'open follow-up': 'seguimiento abierto',
    'open follow-ups': 'seguimientos abiertos',
    'completed follow-up': 'seguimiento completado',
    'completed follow-ups': 'seguimientos completados',
    'No open follow-ups found.': 'No se encontraron seguimientos abiertos.',
    'No completed follow-ups found.': 'No se encontraron seguimientos completados.',
    'Created By': 'Creado por',
    'Created At': 'Creado el',
    'Time Elapsed': 'Tiempo transcurrido',
    'Actions': 'Acciones',
    'View': 'Ver',
    'Assign': 'Asignar',
    'Reassign': 'Reasignar',
    'Claim': 'Tomar',
    'Close': 'Cerrar',
    'Closed': 'Cerrada',
    'Closed Orders': 'Órdenes cerradas',
    'closed order': 'orden cerrada',
    'closed orders': 'órdenes cerradas',
    'Export all closed orders to Excel (respects current date filters)': 'Exportar todas las órdenes cerradas a Excel respetando los filtros de fecha.',
    'Export all closed orders to Excel (respects current filters)': 'Exportar todas las órdenes cerradas a Excel respetando los filtros actuales.',
    'No closed orders found.': 'No se encontraron órdenes cerradas.',
    'Maximum 5 photos allowed.': 'Máximo 5 fotos permitidas.',
    'Maximum 10 photos allowed.': 'Máximo 10 fotos permitidas.',
    'Total photo size limit reached. Remove one photo or upload smaller images.': 'Se alcanzó el límite total de fotos. Elimina una foto o carga imágenes más pequeñas.',
    'Failed to export open orders. Please try again.': 'No se pudieron exportar las órdenes abiertas. Inténtalo de nuevo.',
    'Failed to export closed orders. Please try again.': 'No se pudieron exportar las órdenes cerradas. Inténtalo de nuevo.',
    'Failure Type': 'Tipo de falla',
    'Failure Priority': 'Prioridad de falla',
    'Time Consumed': 'Tiempo consumido',
    'Closed At': 'Cerrado el',
    'Back to List': 'Volver a la lista',
    'Repair Order Detail': 'Detalle de la orden de reparación',
    'Follow-up Detail': 'Detalle del seguimiento',
    'Order Type': 'Tipo de orden',
    'Follow-up Category': 'Categoría de seguimiento',
    'Post-repair visit': 'Visita post-reparación',
    'Order ID:': 'ID de orden:',
    'Status:': 'Estado:',
    'Machine Type': 'Tipo de máquina',
    'Model': 'Modelo',
    'Assigned Technician': 'Técnico asignado',
    'Claimed By': 'Tomado por',
    'Claimed At': 'Tomado el',
    'Resolution': 'Resolución',
    'Source': 'Origen',
    'Part': 'Repuesto',
    'Qty': 'Cant.',
    'Approved By': 'Aprobado por',
    'Reviewed At': 'Revisado el',
    'Review Comment': 'Comentario de revisión',
    'Complaint Details': 'Detalles del reclamo',
    'Issue context and supporting evidence': 'Contexto del problema y evidencia de apoyo',
    'Complaint ID': 'ID del reclamo',
    'WhatsApp Number': 'Número de WhatsApp',
    'Customer Name': 'Nombre del cliente',
    'Total Complaints from Customer': 'Total de reclamos del cliente',
    'No issue photo': 'No hay foto del problema',
    'Tap or click the photo to enlarge it.': 'Toca o haz clic en la foto para ampliarla.',
    'Question Levels': 'Niveles de preguntas',
    'Level 1 Question': 'Pregunta nivel 1',
    'Level 2 Question': 'Pregunta nivel 2',
    'Level 3 Question': 'Pregunta nivel 3',
    'This is the primary action for the assigned technician.': 'Esta es la acción principal para el técnico asignado.',
    'Operators have read-only access to repair closure details.': 'Los operadores tienen acceso de solo lectura a los detalles de cierre de la reparación.',
    'Loading...': 'Cargando...',
    'Click to enlarge': 'Haz clic para ampliar',
    'Click any photo to enlarge.': 'Haz clic en cualquier foto para ampliarla.',
    'Already Closed': 'Ya cerrada',
    'Request Spare Part': 'Solicitar repuesto',
    'Create a linked request without leaving the repair flow.': 'Crea una solicitud vinculada sin salir del flujo de reparación.',
    'Operators cannot create spare-part requests from this view.': 'Los operadores no pueden crear solicitudes de repuestos desde esta vista.',
    'Select Category': 'Seleccionar categoría',
    'Select Spare Part': 'Seleccionar repuesto',
    'Select Category First': 'Selecciona primero una categoría',
    'Quantity': 'Cantidad',
    'Category': 'Categoría',
    'Notes': 'Notas',
    'Reason / additional info for supervisor': 'Motivo / información adicional para supervisor',
    'Send Request': 'Enviar solicitud',
    'Spare Parts Used (Linked)': 'Repuestos usados (vinculados)',
    'Parts already attached to this repair order.': 'Repuestos ya vinculados a esta orden de reparación.',
    'No spare parts linked to this repair yet.': 'Aún no hay repuestos vinculados a esta reparación.',
    'Spare Part Requests for this Ticket': 'Solicitudes de repuestos para este ticket',
    'Track requests already created from this complaint.': 'Da seguimiento a las solicitudes ya creadas desde este reclamo.',
    'No spare part requests linked to this complaint yet.': 'Aún no hay solicitudes de repuestos vinculadas a este reclamo.',
    'Assignment History': 'Historial de asignación',
    'Who claimed or assigned the repair ticket over time.': 'Quién tomó o asignó el ticket de reparación a lo largo del tiempo.',
    'No assignment history yet.': 'Aún no hay historial de asignación.',
    'Repair Photo': 'Foto de reparación',
    'No photo selected': 'No hay foto seleccionada',
    'System': 'Sistema',
    'Electrical Coffee': 'Café eléctrico',
    'Electrical Snack': 'Snack eléctrico',
    'Exterior Coffee': 'Exterior café',
    'Exterior Snack': 'Exterior snack',
    'Hydraulics Coffee': 'Hidráulica café',
    'Hydraulics Snack': 'Hidráulica snack',
    'Mechanical Coffee': 'Mecánica café',
    'Mechanical Snack': 'Mecánica snack',
    'Fully Operational': 'Operativa',
    'Operational with minor issue': 'Operativa con observación',
    'Requires Follow-up': 'Requiere seguimiento',
    'Card payment systems': 'Sistemas de pago con tarjeta',
    'Bill payment systems': 'Sistemas de pago con billetes',
    'Coin payment systems': 'Sistemas de pago con monedas',
    'Compressors': 'Compresores',
    'Locks': 'Cerraduras',
    'CPU cards': 'Tarjetas CPU',
    'Telemetry': 'Telemetría',
    'Drop sensors': 'Sensores de caída',
    'Other': 'Otro',
    'Unknown Technician': 'Técnico desconocido',
    'Unnamed Machine': 'Máquina sin nombre',
    'Unknown Type': 'Tipo desconocido',
    'No location': 'Sin ubicación',
    'No ID': 'Sin ID',
    'Unknown': 'Desconocido',
    'Unnamed user': 'Usuario sin nombre',
    'Stock': 'Inventario',
    'Search': 'Buscar',
    'Edit': 'Editar',
    'Delete': 'Eliminar',
    'Reactivate': 'Reactivar',
    'Confirm Reactivation': 'Confirmar reactivación',
    'Are you sure you want to reactivate': '¿Seguro que quieres reactivar',
    'Are you sure you want to delete': '¿Seguro que quieres eliminar',
    'This action cannot be undone.': 'Esta acción no se puede deshacer.',
    'this machine': 'esta máquina',
    'Machines': 'Máquinas',
    'Edit Machine': 'Editar máquina',
    'View Machine': 'Ver máquina',
    'Add Machine': 'Agregar máquina',
    'Search machine, location, route, model, serial, device ID, external ID, UUID, operator': 'Buscar máquina, ubicación, ruta, modelo, serie, ID de dispositivo, ID externo, UUID u operador',
    'Add New': 'Agregar nueva',
    'Add Spare Parts': 'Agregar Repuestos',
    'New Repair': 'Nueva Reparación',
    'Start': 'Iniciar',
    'Pause': 'Pausar',
    'Continue': 'Continuar',
    'Finish': 'Finalizar',
    'New Spare Part Repair': 'Nueva reparación de repuesto',
    'Finish Repair Task': 'Finalizar reparación',
    'Photos and Comments': 'Fotos y comentarios',
    'Repair Type': 'Tipo de reparación',
    'Select repair type': 'Seleccionar tipo de reparación',
    'Optional': 'Opcional',
    'Timer': 'Temporizador',
    'Running': 'En curso',
    'Paused': 'Pausado',
    'Started At': 'Iniciado el',
    'Total Time': 'Tiempo total',
    'Pauses': 'Pausas',
    'Spare Part Repairs': 'Solicitudes para reparaciones de repuestos',
    'Repair workflow for reusable components with tracked work time.': 'Flujo de reparación de componentes reutilizables con seguimiento del tiempo de trabajo.',
    'Repair type and technician are required.': 'El tipo de reparación y el técnico son obligatorios.',
    'Custom repair type is required.': 'El tipo de reparación personalizado es obligatorio.',
    'No planned repair tasks.': 'No hay reparaciones planificadas.',
    'No repair tasks in progress.': 'No hay reparaciones en progreso.',
    'No completed repair tasks.': 'No hay reparaciones completadas.',
    'planned': 'planificadas',
    'completed': 'completadas',
    'Add a new machine': 'Agregar una nueva máquina',
    'machines': 'máquinas',
    'Filters update the list instantly. Search supports serial, device ID, external ID, UUID, route, machine, and operator.': 'Los filtros actualizan la lista al instante. La búsqueda admite serie, ID de dispositivo, ID externo, UUID, ruta, máquina y operador.',
    'Clear Filters': 'Limpiar filtros',
    'Identity': 'Identidad',
    'Serial Number': 'Número de serie',
    'Serial': 'Serie',
    'Exact serial': 'Serie exacta',
    'Device ID': 'ID de dispositivo',
    'Exact device ID': 'ID de dispositivo exacto',
    'External ID': 'ID externo',
    'Exact external ID': 'ID externo exacto',
    'UUID': 'UUID',
    'Exact UUID': 'UUID exacto',
    'Assignment': 'Asignación',
    'Assigned To': 'Asignado a',
    'All operators': 'Todos los operadores',
    'Classification': 'Clasificación',
    'Route': 'Ruta',
    'All routes': 'Todas las rutas',
    'Type': 'Tipo',
    'All types': 'Todos los tipos',
    'All models': 'Todos los modelos',
    'All locations': 'Todas las ubicaciones',
    'All machines': 'Todas las máquinas',
    'State': 'Estado',
    'Stock Status': 'Estado de inventario',
    'Installed': 'Instalada',
    'In Stock': 'En inventario',
    'Installed + In Stock': 'Instaladas + en inventario',
    'Record Status': 'Estado del registro',
    'Active': 'Activo',
    'Deleted': 'Eliminado',
    'External ID Status': 'Estado del ID externo',
    'Has External ID': 'Tiene ID externo',
    'No External ID': 'Sin ID externo',
    'Has + No External ID': 'Con + sin ID externo',
    'Dates': 'Fechas',
    'Updated From': 'Actualizado desde',
    'Updated To': 'Actualizado hasta',
    'Showing {first} to {last} of {totalRecords} Records': 'Mostrando {first} a {last} de {totalRecords} registros',
    'No List found.': 'No se encontraron registros.',
    'Generate QR': 'Generar QR',
    'Print QR': 'Imprimir QR',
    'Print QR Code': 'Imprimir código QR',
    'QR Code': 'Código QR',
    'Generate QR code for this machine': 'Generar código QR para esta máquina',
    'Print this QR code': 'Imprimir este código QR',
    'Confirm Deletion': 'Confirmar eliminación',
    'Are you sure you want to delete "this machine"? This action cannot be undone.': '¿Seguro que quieres eliminar "esta máquina"? Esta acción no se puede deshacer.',
    'Location': 'Ubicación',
    'Enter Location': 'Ingresar ubicación',
    'Enter Serial Number': 'Ingresar número de serie',
    'Enter Model': 'Ingresar modelo',
    'Select Type': 'Seleccionar tipo',
    'Enter Device Id': 'Ingresar ID de dispositivo',
    'Select Route': 'Seleccionar ruta',
    'Select Machine Name': 'Seleccionar nombre de la máquina',
    'Select User': 'Seleccionar usuario',
    'Condition': 'Condición',
    'Select Machine Condition': 'Seleccionar condición de la máquina',
    'Characteristics': 'Características',
    'Enter Characteristics': 'Ingresar características',
    'Comments': 'Comentarios',
    'Enter Comments': 'Ingresar comentarios',
    'Save': 'Guardar',
    'Update': 'Actualizar',
    'This field is required': 'Este campo es obligatorio',
    'Leading and trailing space is not allowed': 'No se permiten espacios al inicio ni al final',
    'Serial Number contains invalid characters': 'El número de serie contiene caracteres no válidos',
    'Name contains invalid characters': 'El nombre contiene caracteres no válidos',
    'Device ID contains invalid characters': 'El ID de dispositivo contiene caracteres no válidos',
    'Snacks': 'Snacks',
    'Coffee': 'Café',
    'Combo': 'Combo',
    'Drink': 'Bebida',
    'Others': 'Otros',
    'New': 'Nuevo',
    'Ready to Install': 'Lista para instalar',
    'Needs Repair': 'Necesita reparación',
    'Custom / Other': 'Personalizada / Otra',
    'Edit Parts Inventory': 'Editar inventario de repuestos',
    'View Parts Inventory': 'Ver inventario de repuestos',
    'Add Parts Inventory': 'Agregar inventario de repuestos',
    'Add a new part to inventory': 'Agregar un nuevo repuesto al inventario',
    'Pending Spare Part Requests': 'Solicitudes pendientes de repuestos',
    'Shared queue for requests created from repair orders.': 'Cola compartida para solicitudes creadas desde órdenes de reparación.',
    'pending': 'pendientes',
    'No pending spare part requests.': 'No hay solicitudes pendientes de repuestos.',
    'Requested At': 'Solicitado el',
    'Stock Check': 'Verificación de inventario',
    'Current:': 'Actual:',
    'After approval:': 'Después de aprobar:',
    'Reviewed Spare Part Requests': 'Solicitudes revisadas de repuestos',
    'Approved and rejected requests with full review history.': 'Solicitudes aprobadas y rechazadas con historial completo de revisión.',
    'reviewed': 'revisadas',
    'No reviewed spare part requests yet.': 'Aún no hay solicitudes revisadas de repuestos.',
    'Request Notes': 'Notas de la solicitud',
    'Links': 'Enlaces',
    'Inventory Activity': 'Actividad de inventario',
    'Stock ledger for manual changes, approvals, and imports.': 'Historial de inventario para cambios manuales, aprobaciones e importaciones.',
    'activity records': 'registros de actividad',
    'No inventory activity yet.': 'Aún no hay actividad de inventario.',
    'Timestamp': 'Fecha y hora',
    'Action': 'Acción',
    'Before': 'Antes',
    'Delta': 'Cambio',
    'After': 'Después',
    'By': 'Por',
    'Comment': 'Comentario',
    'Filter by SKU': 'Filtrar por SKU',
    'Type SKU': 'Escribir SKU',
    'Filter by Category': 'Filtrar por categoría',
    'Select category': 'Seleccionar categoría',
    'Filter by Description': 'Filtrar por descripción',
    'Type description': 'Escribir descripción',
    'No parts inventory found.': 'No se encontró inventario de repuestos.',
    'Order Number': 'Número de orden',
    'Order Date': 'Fecha de orden',
    'Description': 'Descripción',
    'Price/Unit': 'Precio/unidad',
    'Approve': 'Aprobar',
    'Reject': 'Rechazar',
    'Create Part': 'Crear repuesto',
    'Manual Adjustment': 'Ajuste manual',
    'Approved Request': 'Solicitud aprobada',
    'Import Create': 'Creación por importación',
    'Import Update': 'Actualización por importación',
    'Approve Request: Stock Will Reach Zero': 'Aprobar solicitud: el inventario llegará a cero',
    'Approve Request: Low Stock Warning': 'Aprobar solicitud: advertencia de inventario bajo',
    'Approve Spare Part Request': 'Aprobar solicitud de repuesto',
    'Current stock:': 'Inventario actual:',
    'Requested quantity:': 'Cantidad solicitada:',
    'Stock after approval:': 'Inventario después de aprobar:',
    'This approval will leave this part with zero stock.': 'Esta aprobación dejará este repuesto sin inventario.',
    'This approval will reduce stock below the low-stock threshold of 10.': 'Esta aprobación reducirá el inventario por debajo del umbral de inventario bajo de 10.',
    'Approval comment (optional):': 'Comentario de aprobación (opcional):',
    'Reason / comment for rejection (optional):': 'Motivo / comentario del rechazo (opcional):',
    'Order Number is required': 'El número de orden es obligatorio',
    'Order Number must contain only alphanumeric values and hyphens': 'El número de orden solo debe contener caracteres alfanuméricos y guiones',
    'Order Date is required': 'La fecha de orden es obligatoria',
    'Part Code/SKU is required': 'El código/SKU del repuesto es obligatorio',
    'Part Code must contain only alphanumeric values and hyphens': 'El código del repuesto solo debe contener caracteres alfanuméricos y guiones',
    'Quantity is required': 'La cantidad es obligatoria',
    'Quantity must be at least 1': 'La cantidad debe ser al menos 1',
    'Quantity must be a whole number': 'La cantidad debe ser un número entero',
    'Ordered By is required': 'El campo pedido por es obligatorio',
    'Condition is required': 'La condición es obligatoria',
    'Category is required': 'La categoría es obligatoria',
    'Location is required': 'La ubicación es obligatoria',
    'Price Per Unit must be a valid number': 'El precio por unidad debe ser un número válido',
    'Price Per Unit is required': 'El precio por unidad es obligatorio',
    'Price Per Unit cannot be negative': 'El precio por unidad no puede ser negativo',
    'Price Per Total must be a valid number': 'El precio total debe ser un número válido',
    'Price Per Total is required': 'El precio total es obligatorio',
    'Price Per Total cannot be negative': 'El precio total no puede ser negativo',
    'Description is required': 'La descripción es obligatoria',
    'Description is too short': 'La descripción es demasiado corta',
    'Description must be at most 200 characters': 'La descripción debe tener máximo 200 caracteres',
    'Machine Type is required': 'El tipo de máquina es obligatorio',
    'Inventory Change Comment': 'Comentario de cambio de inventario',
    'Inventory Activity Comment': 'Comentario de actividad de inventario',
    'Optional reason for this stock or inventory update': 'Motivo opcional para esta actualización de inventario',
    'Optional note for this new inventory item': 'Nota opcional para este nuevo artículo de inventario',
    'Enter Order Number (e.g., ORD-2024-001)': 'Ingresar número de orden (ej., ORD-2024-001)',
    'Select Order Date': 'Seleccionar fecha de orden',
    'Part Code/SKU': 'Código del repuesto/SKU',
    'Enter Part Code or SKU (e.g., SKU-ENG-001)': 'Ingresar código del repuesto o SKU (ej., SKU-ENG-001)',
    'Ordered By': 'Pedido por',
    'Select Condition': 'Seleccionar condición',
    'Select machineType': 'Seleccionar tipo de máquina',
    'Enter Description': 'Ingresar descripción',
    'Price Per Unit': 'Precio por unidad',
    'Price Per Total': 'Precio total',
    'Used': 'Usado',
    'Damaged': 'Dañado',
    'Preventive Maintenance & Fumigation Schedule': 'Calendario de mantenimiento preventivo y fumigación',
    'Plan, schedule, and track all preventative maintenance and fumigation tasks.': 'Planifica, agenda y da seguimiento a todas las tareas de mantenimiento preventivo y fumigación.',
    'Schedule Maintenance Task': 'Programar tarea de mantenimiento',
    'Task Type': 'Tipo de tarea',
    'Select task type': 'Seleccionar tipo de tarea',
    'Preventive Type': 'Tipo de preventivo',
    'Operator Preventive': 'Preventivo de operadores',
    'Technical Preventive': 'Preventivo técnico',
    'All Preventive Types': 'Todos los tipos de preventivo',
    'Select preventive type': 'Seleccionar tipo de preventivo',
    'Unnamed team': 'Equipo sin nombre',
    'Select assigned person first': 'Selecciona primero la persona asignada',
    'Select operator task categories': 'Seleccionar categorías de tareas de operador',
    'Select technical task categories': 'Seleccionar categorías de tareas técnicas',
    'Completed Checklist': 'Checklist completado',
    'Select completed tasks': 'Seleccionar tareas completadas',
    'Machine Stocking': 'Abastecimiento de máquinas',
    'Cleaning and Order': 'Limpieza y orden',
    'Hygiene and Pest Control': 'Control de higiene / plagas',
    'Payment System Verification': 'Verificación de sistemas de pago',
    'Machine Operational Verification': 'Verificación operativa de máquina',
    'Allowed Basic Adjustments': 'Ajustes básicos permitidos',
    'Identification and Labeling': 'Identificación y rotulación',
    'Check expiration dates': 'Verificar fechas de vencimiento',
    'Remove damaged product': 'Retiro de producto dañado',
    'Arrange tight spiral products so they drop correctly': 'Acomodar productos apretados en espiral para que caigan correctamente',
    'Clean machine exterior': 'Limpieza externa de la máquina',
    'Basic internal cleaning without technical disassembly': 'Limpieza interna básica (sin desmontaje técnico)',
    'Clean snack trays': 'Limpieza de bandejas (snack)',
    'Clean coffee containers': 'Limpieza de contenedores (café)',
    'Clean area around the machine': 'Limpieza del área alrededor de la máquina',
    'Remove waste': 'Retiro de residuo',
    'Visual inspection for pest presence': 'Inspección visual de presencia de plagas',
    'Clean critical areas': 'Limpieza de zonas críticas (vasos, azúcar, bandejas)',
    'Apply fumigation according to program': 'Aplicación de fumigación (según programa)',
    'Clean compressor grille': 'Limpieza de rejilla de compresor',
    'Test POS card payment': 'Probar POS (tarjeta)',
    'Verify POS TDC version': 'Verificar versión de POS TDC',
    'Validate coin acceptance': 'Validar aceptación de monedas',
    'Validate bill acceptance': 'Validar aceptación de billetes',
    'Confirm there is no stuck credit': 'Confirmar que no haya crédito pegado',
    'Run spiral turn test': 'Ejecutar prueba de giro de espirales',
    'Validate correct product drop': 'Validar caída correcta del producto',
    'Review spiral alignment': 'Revisar alineación de espirales',
    'Verify there are no stuck products': 'Verificar que no haya productos atascados',
    'Verify beverage dispensing': 'Verificar dispensado de bebida',
    'Validate cup delivery': 'Validar entrega de vaso',
    'Check for leaks': 'Revisar que no haya derrames',
    'Arrange misplaced products': 'Acomodar productos mal posicionados',
    'Relocate spirals': 'Reubicar espirales',
    'Adjust trays': 'Ajustar bandejas',
    'Basic machine restart if applicable': 'Reinicio básico de máquina (si aplica)',
    'Change coin mechanism': 'Cambio de monedero',
    'Change telemeter': 'Cambio de telemetro',
    'Change lamps': 'Cambio de lámparas',
    'Change cup system': 'Cambio de sistema de vasos',
    'Change sugar system': 'Cambio de sistema de azúcar',
    'Change containers': 'Cambio de contenedores',
    'Change spirals': 'Cambio de espirales',
    'Place QR on machine': 'Colocar QR en máquina',
    'Replace damaged or missing QR': 'Reemplazar QR dañado o faltante',
    'Change instruction labels': 'Cambiar etiquetas de instrucciones',
    'Place basic labeling': 'Colocar rotulación básica (gavetas, selecciones, precios visibles)',
    'Replace deteriorated labels': 'Reemplazo de etiquetas deterioradas',
    'Assigned Executive/Technician': 'Ejecutivo/técnico asignado',
    'Select operator or technician': 'Seleccionar operador o técnico',
    'Select machines': 'Seleccionar máquinas',
    'Scheduled Date': 'Fecha programada',
    'Select date': 'Seleccionar fecha',
    'Recurrence Rule': 'Regla de recurrencia',
    'Select recurrence': 'Seleccionar recurrencia',
    'Does not repeat': 'No se repite',
    'Every week': 'Cada semana',
    'Every month': 'Cada mes',
    'Every 3 months': 'Cada 3 meses',
    'Additional details': 'Detalles adicionales',
    'Parts Used (planned)': 'Repuestos usados (planificados)',
    'Add Part': 'Agregar repuesto',
    'Select part': 'Seleccionar repuesto',
    'Remove part': 'Eliminar repuesto',
    'No parts added. Click "Add Part" to add parts.': 'No se agregaron repuestos. Haz clic en "Agregar repuesto" para añadir repuestos.',
    'Supervisor Signature (text)': 'Firma del supervisor (texto)',
    'Type supervisor name for approval': 'Escribe el nombre del supervisor para aprobación',
    'This will be stored with timestamp when the task is marked completed.': 'Esto se guardará con marca de tiempo cuando la tarea se marque como completada.',
    'Update Task Status': 'Actualizar estado de la tarea',
    'View Task Details': 'Ver detalles de la tarea',
    'Missed': 'Incumplida',
    'Select status': 'Seleccionar estado',
    'Setting to "In Progress" will update inventory quantities.': 'Cambiar a "En progreso" actualizará las cantidades de inventario.',
    'Completion Notes': 'Notas de finalización',
    'Add notes about the task completion': 'Agregar notas sobre la finalización de la tarea',
    'Completion Photo': 'Foto de finalización',
    'Upload or capture a photo of the completed work.': 'Sube o toma una foto del trabajo completado.',
    'Parts Used (actual)': 'Repuestos usados (reales)',
    'Part not found': 'Repuesto no encontrado',
    'Supervisor Signature': 'Firma del supervisor',
    'Type supervisor name to sign off': 'Escribe el nombre del supervisor para firmar',
    'Signature and timestamp will be stored when you save this update.': 'La firma y la marca de tiempo se guardarán cuando guardes esta actualización.',
    'Schedule Task': 'Programar tarea',
    'Add Task': 'Agregar tarea',
    'Start Date': 'Fecha inicial',
    'Select Start Date': 'Seleccionar fecha inicial',
    'Select End Date': 'Seleccionar fecha final',
    'Customer': 'Cliente',
    'Enter Customer Name': 'Ingresar nombre del cliente',
    'Executive': 'Ejecutivo',
    'Enter Executive Name': 'Ingresar nombre del ejecutivo',
    'Apply Filters': 'Aplicar filtros',
    'Reset': 'Restablecer',
    'Total Tasks': 'Total de tareas',
    'In Progress': 'En progreso',
    'Adherence Rate': 'Tasa de cumplimiento',
    'Closed Tasks Summary - Last Month': 'Resumen de tareas cerradas - último mes',
    'Only completed or missed tasks closed in the last month are included.': 'Solo se incluyen tareas completadas o incumplidas cerradas en el último mes.',
    'Adherence by Category (current filters)': 'Cumplimiento por categoría (filtros actuales)',
    'Adherence by Category - Closed Tasks Last Month': 'Cumplimiento por categoría - tareas cerradas del último mes',
    'No category data available.': 'No hay datos de categoría disponibles.',
    'Preventive Maintenance Calendar': 'Calendario de mantenimiento preventivo',
    'Preventive Maintenance Adherence Report': 'Reporte de cumplimiento de mantenimiento preventivo',
    'No preventive maintenance data found.': 'No se encontraron datos de mantenimiento preventivo.',
    'Task ID': 'ID de tarea',
    'Completed Date': 'Fecha de finalización',
    'Parts Used': 'Repuestos usados',
    'Adherence %': '% de cumplimiento',
    'Update Status': 'Actualizar estado',
    'Are you sure you want to delete this task? This action cannot be undone.': '¿Seguro que quieres eliminar esta tarea? Esta acción no se puede deshacer.',
    'Failed to export data. Please try again.': 'No se pudieron exportar los datos. Inténtalo de nuevo.',
    'Fumigation': 'Fumigación',
    'Fumigation and General Cleaning': 'Fumigación y limpieza general',
    'General Cleaning': 'Limpieza general',
    'Filter Replacement': 'Cambio de filtro',
    'Overdue': 'Atrasado',
    'Due Date': 'Fecha límite',
    'Pending Maintenance Tasks': 'Tareas de mantenimiento pendientes',
    'Closed Maintenance Tasks': 'Tareas de mantenimiento cerradas',
    'pending task': 'tarea pendiente',
    'pending tasks': 'tareas pendientes',
    'closed task': 'tarea cerrada',
    'closed tasks': 'tareas cerradas',
    'No pending maintenance tasks found.': 'No se encontraron tareas pendientes.',
    'No closed maintenance tasks found.': 'No se encontraron tareas cerradas.',
    'Task Details': 'Detalles de la tarea',
    'View Full Details': 'Ver detalles completos',
    'Show Filters': 'Mostrar filtros',
    'Hide Filters': 'Ocultar filtros',
    'Multiple machines': 'Varias máquinas',
    'Loading preventive maintenance data...': 'Cargando datos de mantenimiento preventivo...',
    'Data load issue': 'Problema al cargar datos',
    'Retry': 'Reintentar',
    'There is no data to export for this section.': 'No hay datos para exportar en esta sección.',
    'Completion Photos': 'Fotos de finalización',
    'Maximum 5 photos allowed.': 'Máximo 5 fotos permitidas.',
    'photos': 'fotos',
    'Photo': 'Foto',
    'On Time': 'Puntualidad',
    'On time': 'A tiempo',
    'Late': 'Atrasado',
    'Machines Not Visited': 'Máquinas no visitadas',
    'Days Since Service': 'Días sin servicio',
    'Not Visited (5+ days)': 'Sin visita (5+ días)',
    'days': 'días',
    'Online': 'En línea',
    'Route Performance': 'Rendimiento de rutas',
    'Score': 'Puntaje',
    'Rating': 'Calificación',
    '$/Machine': '$/Máquina',
    'Schedule Anomalies': 'Anomalías de horario',
    'Gap': 'Brecha',
    'After Hours': 'Fuera de horario',
    'gaps': 'brechas',
    'after hrs': 'fuera de horario',
    'Detail': 'Detalle',
    'No schedule anomalies detected': 'No se detectaron anomalías de horario',
    'Customer Complaint Reports': 'Reportes de reclamos de clientes',
    'Monthly customer scorecard for selected machines, focused on complaint volume, resolution, and recurring problem areas.': 'Resumen mensual de clientes para las máquinas seleccionadas, enfocado en volumen de reclamos, resolución y áreas de problemas recurrentes.',
    'Machines': 'Máquinas',
    'Period': 'Período',
    'Month': 'Mes',
    'Type a machine, location, serial, device ID, or UUID': 'Escribe una máquina, ubicación, serial, ID del dispositivo o UUID',
    'Select month': 'Seleccionar mes',
    'Select date range': 'Seleccionar rango de fechas',
    'Clear Selection': 'Limpiar selección',
    'Select machines to build the report': 'Selecciona máquinas para generar el reporte',
    'You can type names like Metro, location text, serial numbers, device IDs, or UUIDs.': 'Puedes escribir nombres como Metro, texto de ubicación, números de serie, IDs de dispositivo o UUIDs.',
    'Complaints Opened': 'Reclamos abiertos',
    'Resolved %': '% resuelto',
    'Average Resolution Time': 'Tiempo promedio de resolución',
    'Currently Open': 'Abiertos actualmente',
    'Most Affected Machine': 'Máquina más afectada',
    'complaint': 'reclamo',
    'complaints': 'reclamos',
    'No complaints for the selected month.': 'No hay reclamos para el mes seleccionado.',
    'Complaint Date': 'Fecha del reclamo',
    'No customers available': 'No hay clientes disponibles',
    'No complaints match the selected filters.': 'No hay reclamos que coincidan con los filtros seleccionados.',
    'Complaints by Status': 'Reclamos por estado',
    'No complaint status data for the selected month.': 'No hay datos de estado de reclamos para el mes seleccionado.',
    'Complaints by Machine': 'Reclamos por máquina',
    'No machine complaint data for the selected month.': 'No hay datos de reclamos por máquina para el mes seleccionado.',
    'Complaint Trend by Week': 'Tendencia de reclamos por semana',
    'No weekly complaint data for the selected month.': 'No hay datos semanales de reclamos para el mes seleccionado.',
    'Top Affected Locations': 'Ubicaciones más afectadas',
    'No location complaint data for the selected month.': 'No hay datos de reclamos por ubicación para el mes seleccionado.',
    'Location Summary': 'Resumen por ubicación',
    'Level 1 Breakdown': 'Desglose nivel 1',
    'Level 2 Breakdown': 'Desglose nivel 2',
    'Level 3 Breakdown': 'Desglose nivel 3',
    'Chat Selection Breakdown': 'Desglose de selección del chat',
    'No chat selection data for the selected month.': 'No hay datos de selección del chat para el mes seleccionado.',
    'Manual Ticket': 'Ticket manual',
    'Written Detail': 'Detalle escrito',
    'Scheduled preventive maintenance for the selected machines and month.': 'Mantenimiento preventivo programado para las máquinas seleccionadas y el mes elegido.',
    'No preventive maintenance tasks for the selected month.': 'No hay tareas de mantenimiento preventivo para el mes seleccionado.',
    'Closed Repair Orders': 'Órdenes cerradas',
    'Closed repair work for the selected machines and period.': 'Órdenes de reparación cerradas para las máquinas y período seleccionado.',
    'average close time': 'tiempo promedio de cierre',
    'closed under 24h': 'cerradas en menos de 24h',
    'Top failure': 'Falla más frecuente',
    'No closed repair orders were recorded for the selected machines and period.': 'No se registraron órdenes cerradas para las máquinas y período seleccionado.',
    'Close Date': 'Fecha de cierre',
    'Action Performed': 'Acción realizada',
    'Close Time': 'Tiempo de cierre',
    'Result': 'Resultado',
    Unspecified: 'Sin especificar',
    'Preventive Maintenance Completed': 'Mantenimientos preventivos completados',
    'Preventive Maintenance Missed': 'Mantenimientos preventivos incumplidos',
    'Preventive Maintenance Adherence': 'Cumplimiento de mantenimiento preventivo',
    'Top Problem Themes': 'Temas principales de problemas',
    'No problem theme data for the selected month.': 'No hay datos de temas de problemas para el mes seleccionado.',
    'SLA / Resolution Bands': 'SLA / rangos de resolución',
    'No SLA data for the selected month.': 'No hay datos de SLA para el mes seleccionado.',
    'Problem Theme Summary': 'Resumen de temas de problemas',
    'Problem': 'Problema',
    '% of Total': '% del total',
    'Machines Affected': 'Máquinas afectadas',
    'Latest Case': 'Último caso',
    'Origin Type': 'Tipo de origen',
    'WhatsApp Menu': 'Menú de WhatsApp',
    'QR / Repair Flow': 'Flujo QR / reparación',
    'Manual Ticket / Panel': 'Ticket manual / panel',
    'Problem Theme': 'Tema del problema',
    'Cash / Bill Acceptor': 'Efectivo / billetero',
    'Card / POS Payment': 'Tarjeta / punto de pago',
    'Product Not Delivered': 'Producto no entregado',
    'Cleaning / Hygiene': 'Limpieza / higiene',
    'Display / Screen': 'Pantalla',
    'Phone / Contact Sticker': 'Teléfono / sticker de contacto',
    'Lighting': 'Iluminación',
    'Pricing': 'Precios',
    'Water / Coffee System': 'Agua / sistema de café',
    'Other / Written Detail': 'Otro / detalle escrito',
    'Closed under 24h': 'Cerrado en menos de 24h',
    'Closed 24-48h': 'Cerrado en 24-48h',
    'Closed 48h+': 'Cerrado en más de 48h',
    'Still Open': 'Sigue abierto',
    'SLA Band': 'Rango SLA',
    'Repeat Complaint': 'Reclamo repetido',
    'Repeat': 'Repetido',
    'No Repair Order': 'Sin orden de reparación',
    'Repair Order': 'Orden de reparación',
    'Repair Status': 'Estado de reparación',
    'Failure Type': 'Tipo de falla',
    'Failure Category': 'Categoría de falla',
    'Repair Time': 'Tiempo de reparación',
    'Actions Taken': 'Acciones tomadas',
    'Executive Summary': 'Resumen ejecutivo',
    'Top Problem Theme': 'Tema principal de problema',
    'SLA / Resolution Band': 'SLA / rango de resolución',
    'Metric': 'Métrica',
    'Value': 'Valor',
    tasks: 'tareas',
    adherence: 'cumplimiento',
    'No Level 1 complaints for the selected month.': 'No hay reclamos de nivel 1 para el mes seleccionado.',
    'No Level 2 complaints for the selected month.': 'No hay reclamos de nivel 2 para el mes seleccionado.',
    'No Level 3 complaints for the selected month.': 'No hay reclamos de nivel 3 para el mes seleccionado.',
    'Count': 'Cantidad',
    'Complaint Detail': 'Detalle del reclamo',
    'Report Type': 'Tipo de reporte',
    'Complaint': 'Reclamo',
    'Created At': 'Creado el',
    'Closed At': 'Cerrado el',
    'WhatsApp': 'WhatsApp',
    'Issue Summary': 'Resumen del problema',
    'Summary': 'Resumen',
    'Machine and Selection': 'Máquina y selección',
    'Photos': 'Fotos',
    'Chat History': 'Historial del chat',
    'Conversation with customer': 'Conversación con el cliente',
    'Read-only context for the assigned technician': 'Contexto de solo lectura para el técnico asignado',
    'No public conversation was saved for this ticket.': 'No se guardó una conversación pública para este ticket.',
    'messages': 'mensajes',
    'Sender': 'Remitente',
    'Message': 'Mensaje',
    'Image or attachment': 'Imagen o adjunto',
    'No chat history was saved for this older ticket.': 'No se guardó historial de chat para este ticket anterior.',
    'Timeline / Status Logs': 'Línea de tiempo / registros de estado',
    'No status logs found for this complaint.': 'No hay registros de estado para este reclamo.',
    'Updated By': 'Actualizado por',
    'No repair orders linked to this complaint.': 'No hay órdenes de reparación vinculadas a este reclamo.',
    'Awaiting Customer': 'Esperando al cliente',
    'Unknown': 'Desconocido',
    'Unnamed Machine': 'Máquina sin nombre',
    'Unknown Type': 'Tipo desconocido',
    'No location': 'Sin ubicación',
    'No ID': 'Sin ID',
    'Open Chat': 'Abrir chat',
    'Open chat with this complain': 'Abrir chat con este reclamo',
    'Search by machine, VM-467, serial, phone, location...': 'Buscar por máquina, VM-467, serial, teléfono, ubicación...',
    'WhatsApp Number': 'Número de WhatsApp',
    'Chat': 'Chat',
    'From date': 'Fecha desde',
    'To date': 'Fecha hasta',
    'Open': 'Abierto',
    'Closed': 'Cerrado',
    'No rating': 'Sin calificación',
    'User Rating': 'Calificación del usuario',
    'Search complaints...': 'Buscar reclamos...',
    'No removals found': 'No se encontraron retiros',
    'Machine Movement Reports': 'Reportes de movimientos de máquinas',
    'Track installations, removals, and exchanges across all machines.': 'Da seguimiento a instalaciones, retiros e intercambios en todas las máquinas.',
    'Installation': 'Instalación',
    'Removal': 'Retiro',
    'Remove': 'Retiro',
    'Removed': 'Retirada',
    'Exchanged - Installed': 'Intercambio - instalado',
    'Exchanged - Removed': 'Intercambio - retirado',
    'Yes': 'Sí',
    'No': 'No',
    'N/A': 'N/A',
    'Ready to Close': 'Lista para cerrar',
    'New Machine Movement': 'Nuevo movimiento de máquina',
    'Assigned Technician': 'Técnico asignado',
    'Select technician': 'Seleccionar técnico',
    'Customer name': 'Nombre del cliente',
    'Select movement type': 'Seleccionar tipo de movimiento',
    'From Location': 'Ubicación de origen',
    'e.g., Warehouse': 'Ej., almacén',
    'To Location': 'Ubicación de destino',
    'Destination location': 'Ubicación de destino',
    'Installation Date': 'Fecha de instalación',
    'Select one day or a date range': 'Selecciona un día o un rango de fechas',
    'Machine (Optional)': 'Máquina (opcional)',
    'Select machine (ID - Type - Location)': 'Seleccionar máquina (ID - tipo - ubicación)',
    'Type': 'Tipo',
    'Snack': 'Snack',
    'Movement Photos': 'Fotos del movimiento',
    'Optional. Up to {0} photos, max 300 KB each.': 'Opcional. Hasta {0} fotos, máximo 300 KB cada una.',
    'photo added': 'foto agregada',
    'photos added': 'fotos agregadas',
    'Click to enlarge': 'Haz clic para ampliar',
    'Remove': 'Eliminar',
    'Comments': 'Comentarios',
    'Additional notes': 'Notas adicionales',
    'Cancel': 'Cancelar',
    'Save': 'Guardar',
    'Close Pending Movement': 'Cerrar movimiento pendiente',
    'Checklist': 'Lista de verificación',
    'Open Checklist': 'Abrir lista de verificación',
    'Complete required checklist items before closing this movement.': 'Completa los elementos obligatorios de la lista antes de cerrar este movimiento.',
    'Final Status': 'Estado final',
    'Select final status': 'Seleccionar estado final',
    'Machine ID': 'ID de máquina',
    'Close Comments': 'Comentarios de cierre',
    'Add technician notes about the close action': 'Agregar notas del técnico sobre el cierre',
    'Close Photos': 'Fotos de cierre',
    'Close Movement': 'Cerrar movimiento',
    'Complete checklist first': 'Completa la lista primero',
    'Movement Details': 'Detalles del movimiento',
    'Delete Movement': 'Eliminar movimiento',
    'Confirm Pending Movement Deletion': 'Confirmar eliminación del movimiento pendiente',
    'Are you sure you want to delete this pending movement? This action cannot be undone.': '¿Seguro que quieres eliminar este movimiento pendiente? Esta acción no se puede deshacer.',
    'Pending movement deleted successfully': 'Movimiento pendiente eliminado correctamente',
    'Close as': 'Cerrar como',
    'Requested By': 'Solicitado por',
    'Current Status': 'Estado actual',
    'Requested Final Type': 'Tipo final solicitado',
    'Checklist Template': 'Plantilla de lista de verificación',
    'Requested At': 'Solicitado el',
    'Request Comments': 'Comentarios de la solicitud',
    'Request Photos': 'Fotos de la solicitud',
    'No photo': 'Sin foto',
    'Data Quality Prompts': 'Alertas de calidad de datos',
    'No data quality issues detected.': 'No se detectaron problemas de calidad de datos.',
    'Audit Timeline': 'Línea de auditoría',
    'By:': 'Por:',
    'Movement request created': 'Solicitud de movimiento creada',
    'Movement closed as': 'Movimiento cerrado como',
    'Machine ID is missing.': 'Falta el ID de la máquina.',
    'Machine Type is missing.': 'Falta el tipo de máquina.',
    'Requester is missing (legacy record or unknown user).': 'Falta el solicitante (registro antiguo o usuario desconocido).',
    'Checklist is incomplete ({0}%). Complete required items before closing.': 'La lista de verificación está incompleta ({0}%). Completa los elementos obligatorios antes de cerrar.',
    'Open movement is older than 2 hours and has no request photo.': 'El movimiento abierto tiene más de 2 horas y no tiene foto de solicitud.',
    'Closed movement has no close photo.': 'El movimiento cerrado no tiene foto de cierre.',
    'Closed movement has no close comments.': 'El movimiento cerrado no tiene comentarios de cierre.',
    'General Information': 'Información general',
    'Machine Code': 'Código de máquina',
    'POS Code': 'Código POS',
    'Parlevel/Telemetro Code': 'Código Parlevel/Telemetro',
    'Technician Name': 'Nombre del técnico',
    'Required completed:': 'Obligatorios completados:',
    'Notes': 'Notas',
    'Evidence Photos': 'Fotos de evidencia',
    'Optional. Up to 5 photos, 300 KB each.': 'Opcional. Hasta 5 fotos, 300 KB cada una.',
    'Remove photo': 'Eliminar foto',
    'Attach photo': 'Adjuntar foto',
    'Photo sent': 'Foto enviada',
    'Message sent': 'Mensaje enviado',
    'Send human follow-up?': '¿Enviar seguimiento humano?',
    'The bot already answered the latest customer message. Your message is different and can be sent as an additional human follow-up.': 'El bot ya respondió el último mensaje del cliente. Su mensaje es diferente y puede enviarse como un seguimiento humano adicional.',
    'Send follow-up': 'Enviar seguimiento',
    'This exact follow-up was already sent': 'Este seguimiento exacto ya fue enviado.',
    'Another response is still being sent. Please try again.': 'Todavía se está enviando otra respuesta. Intente nuevamente.',
    'Sending...': 'Enviando...',
    'You can add an optional caption in the message box.': 'Puedes agregar un texto opcional en el cuadro de mensaje.',
    'Section Notes': 'Notas de la sección',
    'Movement Photo': 'Foto del movimiento',
    'Photo failed to load.': 'No se pudo cargar la foto.',
    'Machine Movements Summary': 'Resumen de movimientos de máquinas',
    'Pending:': 'Pendientes:',
    'Completed Movements:': 'Movimientos completados:',
    'Total Removals:': 'Total de retiros:',
    'Total Exchanges:': 'Total de intercambios:',
    'Customer Churn Analysis': 'Análisis de rotación de clientes',
    'Removals by Reason:': 'Retiros por motivo:',
    'New Movement': 'Nuevo movimiento',
    'Pending Movements': 'Movimientos pendientes',
    'pending movement': 'movimiento pendiente',
    'pending movements': 'movimientos pendientes',
    'Export XLSX': 'Exportar XLSX',
    'Export visible pending columns to XLSX': 'Exportar columnas visibles pendientes a XLSX',
    'Export CSV': 'Exportar CSV',
    'Export visible pending columns to CSV': 'Exportar columnas visibles pendientes a CSV',
    'Filter by Date - From': 'Filtrar por fecha - desde',
    'Filter by Date - To': 'Filtrar por fecha - hasta',
    'Start date': 'Fecha inicial',
    'End date': 'Fecha final',
    'Clear Filter': 'Limpiar filtro',
    'No pending movements found.': 'No se encontraron movimientos pendientes.',
    'Completed movement': 'movimiento completado',
    'completed movement': 'movimiento completado',
    'completed movements': 'movimientos completados',
    'Completed By': 'Completado por',
    'Completed At': 'Completado el',
    'No completed movements found.': 'No se encontraron movimientos completados.',
    'Actions': 'Acciones',
    'Week': 'Semana',
    'Complaints': 'Reclamos',
    'Forwarded': 'Reenviado',
    // Complaint status `in_progress` only. The DB value is unchanged — this is the label
    // agents see, and in practice an in_progress complaint means it went to the refund
    // queue (28 of 29 carry a refund sub-document). Deliberately NOT reusing
    // 'In Progress', which spare-part repair tasks and HR also use.
    'Sent to Finance': 'Enviado a finanzas',
    'Exclusive route: Technicians': 'Ruta exclusiva: Técnicos',
    'Exclusive route: Finance': 'Ruta exclusiva: Finanzas',
    'Route conflict: Technicians and Finance': 'Conflicto de ruta: Técnicos y Finanzas',
    'Finance': 'Finanzas',
    // Marks a chat entry the customer never received (audit note, menu marker).
    'Internal note': 'Nota interna — no enviada al cliente',
    // Dashboard: date-range presets and the "needs attention" row.
    'Showing': 'Mostrando',
    'All time': 'Todo el historial',
    'Today': 'Hoy',
    'This week': 'Esta semana',
    'This month': 'Este mes',
    'Last 30 days': 'Últimos 30 días',
    'Waiting on us': 'Esperando respuesta',
    'Customer spoke last': 'El cliente escribió último',
    'No reply over 3 days': 'Sin respuesta +3 días',
    'Waiting more than': 'Esperando más de',
    'days': 'días',
    'In the finance queue': 'En cola de finanzas',
    'Awaiting a refund decision': 'Pendiente de decisión de reembolso',
    'Incomplete refunds': 'Reembolsos incompletos',
    'Missing bank details': 'Faltan datos bancarios',
    'Others': 'Otras',
    'Most complaints first': 'Más reclamos primero',
    'Needs reply': 'Requiere respuesta',
    'Operator': 'Operador',
    'Operator (WhatsApp)': 'Operador (WhatsApp)',
    'Reported by one of our operators, not a customer': 'Reportado por un operador nuestro, no por un cliente',
    'Only tickets where the customer is waiting on us': 'Solo tickets donde el cliente espera nuestra respuesta',
    'Not waiting on us': 'No espera respuesta',
    'Waiting': 'Esperando',
    'Age': 'Antigüedad',
    'Draft ready': 'Borrador listo',
    'Automation': 'Automatización',
    'Automation state': 'Estado de automatización',
    'All automation states': 'Todos los estados de automatización',
    'Automatic': 'Automático',
    'Human review': 'Revisión humana',
    'Human owned': 'Asignado a una persona',
    'Automation off': 'Automatización desactivada',
    'Automatic message budget': 'Límite de mensajes automáticos',
    'Test reply budget': 'Límite de respuestas de prueba',
    'Live test: real WhatsApp': 'Prueba activa: WhatsApp real',
    'Pending send in': 'Envío pendiente en',
    'Take over': 'Tomar control',
    'Release': 'Liberar',
    'Ticket claimed': 'Ticket tomado',
    'Ticket released': 'Ticket liberado',
    'Reason': 'Motivo',
    'Required specialist': 'Especialista requerido',
    'Proposed reply': 'Respuesta propuesta',
    'Latest request': 'Solicitud más reciente',
    'Complaint agent': 'Agente de reclamos',
    'Agent off': 'Agente apagado',
    'Agent on (shadow)': 'Agente activo (sombra)',
    'Agent live (all tickets)': 'Agente activo (todos los tickets)',
    'Agent live (canary)': 'Agente activo (canario)',
    'Agent configured, server disabled': 'Agente configurado, servidor deshabilitado',
    'Turn agent on (live)': 'Encender agente (en vivo)',
    'Start agent evaluation': 'Iniciar evaluación del agente',
    'Turn on for all tickets': 'Encender para todos los tickets',
    'Start shadow evaluation': 'Iniciar evaluación en sombra',
    'Turn agent off': 'Apagar agente',
    'Activate ticket agent?': '¿Activar el agente de tickets?',
    'Turn off ticket agent?': '¿Apagar el agente de tickets?',
    'This enables automated customer messages for every eligible ticket. High-risk cases will still be routed to human review.': 'Esto habilita mensajes automáticos a clientes para cada ticket elegible. Los casos de alto riesgo seguirán siendo enviados a revisión humana.',
    'This starts shadow evaluation for eligible tickets. Decisions are audited, but no customer messages are sent.': 'Esto inicia la evaluación en sombra para los tickets elegibles. Las decisiones quedan auditadas, pero no se envían mensajes a clientes.',
    'This stops new analysis and activates the kill switch.': 'Esto detiene los análisis nuevos y activa el interruptor de emergencia.',
    'Agent is live for all eligible tickets.': 'El agente está activo para todos los tickets elegibles.',
    'Agent shadow evaluation started. No customer messages will be sent.': 'La evaluación en sombra comenzó. No se enviarán mensajes a clientes.',
    'Agent turned off.': 'Agente apagado.',
    'Server enablement is required before the agent can be activated.': 'Se requiere habilitación en el servidor antes de poder activar el agente.',
    'Turn off automation immediately.': 'Apagar la automatización inmediatamente.',
    'Live mode can send customer messages after the configured delay.': 'El modo en vivo puede enviar mensajes a clientes después de la demora configurada.',
    'Shadow mode evaluates eligible tickets without sending customer messages.': 'El modo sombra evalúa tickets elegibles sin enviar mensajes a clientes.',
    'An AI suggestion is ready for this ticket': 'Hay una sugerencia de IA lista para este ticket',
    'Origin': 'Origen',
    'All origins': 'Todos los orígenes',
    'Customer (WhatsApp)': 'Cliente (WhatsApp)',
    'Internal (portal)': 'Interno (portal)',
    'Fastest first': 'Más rápido primero',
    'excluded with under 10 tickets': 'excluidos con menos de 10 tickets',
    'Hours to close (average)': 'Horas para cerrar (promedio)',
    'tickets closed': 'tickets cerrados',
    'Unassigned': 'Sin asignar',
    'machines with 5 or more': 'máquinas con 5 o más',
    'Tickets': 'Tickets',
    'Week starting (Monday)': 'Semana iniciando (lunes)',
    'Partial week (cut off by the selected range)': 'Semana parcial (recortada por el rango seleccionado)',
    'Movement ID': 'ID del movimiento',
    'Checklist Status': 'Estado de la lista de verificación',
    'This movement does not have a checklist template.': 'Este movimiento no tiene una plantilla de lista de verificación.',
    'Maximum 5 photos allowed.': 'Máximo 5 fotos permitidas.',
    'Total photo size limit reached. Remove one photo or upload smaller images.': 'Se alcanzó el límite total de tamaño de fotos. Elimina una foto o sube imágenes más pequeñas.',
    'Complete the checklist before closing this movement.': 'Completa la lista de verificación antes de cerrar este movimiento.',
    'Select machine (optional)': 'Seleccionar máquina (opcional)',
    'No movement selected.': 'No hay movimiento seleccionado.',
    'Closed movement checklist is read-only': 'La lista de verificación del movimiento cerrado es solo lectura',
    'Loading checklist...': 'Cargando lista de verificación...',
    'Checklist not available for this movement.': 'La lista de verificación no está disponible para este movimiento.',
    'Template:': 'Plantilla:',
    'Complete required items to reach 100% and allow movement closure.': 'Completa los elementos obligatorios para llegar al 100% y permitir el cierre del movimiento.',
    'Model': 'Modelo',
    'No movement selected.': 'No hay movimiento seleccionado.',
    'Movement': 'Movimiento',
    'Please enter a valid email': 'Ingresa un correo electrónico válido',
    'Email is required': 'El correo electrónico es obligatorio',
    'Password is required': 'La contraseña es obligatoria',
    'Welcome': 'Bienvenido',
    'Please login to admin dashboard': 'Inicia sesión en el panel de administración',
    'Admin portal to manage machines, teams, users and complaints in one place.': 'Portal administrativo para gestionar máquinas, equipos, usuarios y reclamos en un solo lugar..',
    'Monitor machine status, locations and routes in real time.': 'Monitorea el estado de las máquinas, ubicaciones y rutas en tiempo real.',
    'Track complaints, chat with customers and close tickets faster.': 'Da seguimiento a reclamos, conversa con clientes y cierra tickets más rápido.',
    'Control users, teams and spare parts inventory from one place.': 'Controla usuarios, equipos e inventario de repuestos desde un solo lugar.',
    'SYNCRO. All rights reserved. This admin portal is intended for authorised staff only and provides access to operational data, analytics and customer interactions.': 'SYNCRO. Todos los derechos reservados. Este portal administrativo está destinado únicamente al personal autorizado y brinda acceso a datos operativos, analítica e interacciones con clientes.',
    'Use your admin credentials to sign in.': 'Usa tus credenciales de administrador para iniciar sesión.',
    'Forgot password?': '¿Olvidaste tu contraseña?',
    'Please enter your email.': 'Ingresa tu correo electrónico.',
    'OTP sent to your email.': 'Se envió un OTP a tu correo electrónico.',
    'OTP sent to your registered email.': 'Se envió un OTP a tu correo electrónico registrado.',
    'Forgot Password': 'Olvidé mi contraseña',
    'Verify OTP': 'Verificar OTP',
    'Reset Password': 'Restablecer contraseña',
    'Back to Login': 'Volver al inicio de sesión',
    'We have sent a 4-digit OTP to': 'Hemos enviado un OTP de 4 dígitos a',
    'Please enter it below.': 'Por favor ingrésalo abajo.',
    'OTP': 'OTP',
    'Enter 4-digit OTP': 'Ingresa el OTP de 4 dígitos',
    'Back': 'Atrás',
    'Resend OTP': 'Reenviar OTP',
    'Create a new password for your account.': 'Crea una nueva contraseña para tu cuenta.',
    'Password Update Required': 'Actualización de contraseña requerida',
    'For security reasons, you must create a new password before continuing.': 'Por razones de seguridad, debes crear una nueva contraseña antes de continuar.',
    'New Password': 'Nueva contraseña',
    'Enter new password': 'Ingresa la nueva contraseña',
    'Confirm Password': 'Confirmar contraseña',
    'Re-enter new password': 'Vuelve a ingresar la nueva contraseña',
    'Password reset successfully. Please login with your new password.': 'La contraseña se restableció correctamente. Inicia sesión con tu nueva contraseña.',
    'ACCESS': 'ACCESO',
    'denied': 'denegado',
    'You are not allowed to view this page.': 'No tienes permiso para ver esta página.',
    'Go back to home': 'Volver al inicio',
    'ERROR': 'ERROR',
    "something's went wrong": 'algo salió mal',
    'not found': 'no encontrada',
    'The page that you are looking for does not exist': 'La página que estás buscando no existe',
    'My Profile': 'Mi perfil',
    'Profile': 'Perfil',
    'No email': 'Sin correo electrónico',
    'No phone': 'Sin teléfono',
    'Edit Profile': 'Editar perfil',
    'Preferred Language': 'Idioma preferido',
    'Phone Number': 'Número de teléfono',
    'Update Profile': 'Actualizar perfil',
    'Account Information': 'Información de la cuenta',
    'User ID': 'ID de usuario',
    'Account Status': 'Estado de la cuenta',
    'Last Updated At': 'Última actualización',
    'Registered Email': 'Correo registrado',
    "We'll send an OTP to this email to verify your identity.": 'Enviaremos un OTP a este correo para verificar tu identidad.',
    'Enter OTP': 'Ingresar OTP',
    'Update Password': 'Actualizar contraseña',
    'User ID not found. Please log in again.': 'No se encontró el ID de usuario. Inicia sesión nuevamente.',
    'Failed to update profile. Please try again.': 'No se pudo actualizar el perfil. Inténtalo de nuevo.',
    'An error occurred while updating profile. Please try again.': 'Ocurrió un error al actualizar el perfil. Inténtalo de nuevo.',
    'Email not found for this user.': 'No se encontró correo electrónico para este usuario.',
    'OTP resent successfully.': 'El OTP se reenviò correctamente.',
    'OTP verified successfully.': 'OTP verificado correctamente.',
    'Please enter a new password.': 'Ingresa una nueva contraseña.',
    'Password updated successfully.': 'La contraseña se actualizó correctamente.',
    'Password updated successfully. Please login again.': 'La contraseña se actualizó correctamente. Inicia sesión nuevamente.',
    'New password and confirm password do not match.': 'La nueva contraseña y su confirmación no coinciden.',
    'First name is required': 'El nombre es obligatorio',
    'First name must be at least 2 characters': 'El nombre debe tener al menos 2 caracteres',
    'Last name is required': 'El apellido es obligatorio',
    'Last name must be at least 2 characters': 'El apellido debe tener al menos 2 caracteres',
    'Phone number is required': 'El número de teléfono es obligatorio',
    'Phone number must be at least 10 digits': 'El número de teléfono debe tener al menos 10 dígitos',
    'Unknown machine': 'Máquina desconocida',
    'Unknown location': 'Ubicación desconocida',
    'Ticket created': 'Ticket creado',
    'Level 1 selected': 'Nivel 1 seleccionado',
    'Level 2 selected': 'Nivel 2 seleccionado',
    'Level 3 selected': 'Nivel 3 seleccionado',
    'Team assigned': 'Equipo asignado',
    'Status updated': 'Estado actualizado',
    'Assigned to': 'Asignado a',
    'Create Repair Order?': '¿Crear orden de reparación?',
    'Do you want to create a repair order for this complaint?': '¿Deseas crear una orden de reparación para este reclamo?',
    'Reroute Complaint?': '¿Reenrutar reclamo?',
    'This complaint has an open Repair Order. Rerouting it will remove that Repair Order from Repair Orders, reports, and exports. Continue?': 'Este reclamo tiene una orden de reparación abierta. Si lo reenrutas, esa orden desaparecerá de Órdenes de Reparación, reportes y exportaciones. ¿Deseas continuar?',
    'Chat Box': 'Chat',
    'Frequent customer': 'Cliente frecuente',
    'complaints recorded': 'reclamos registrados',
    'Ticket': 'Ticket',
    'No messages yet for this ticket.': 'Aún no hay mensajes para este ticket.',
    'No chat history was saved for this older ticket. Showing the available complaint timeline instead.': 'No se guardó historial de chat para este ticket anterior. Mostrando en su lugar la línea de tiempo disponible del reclamo.',
    'Updated by': 'Actualizado por',
    'Chat image': 'Imagen del chat',
    'Image failed to load': 'No se pudo cargar la imagen',
    'Media unavailable (historical)': 'Media no disponible (histórico)',
    'Complaint is closed. Chat is disabled.': 'El reclamo está cerrado. El chat está deshabilitado.',
    'Type a message...': 'Escribe un mensaje...',
    'Send': 'Enviar',
    'Complaint Details': 'Detalles del reclamo',
    'WhatsApp Number': 'Número de WhatsApp',
    'Customer Name': 'Nombre del cliente',
    'Add customer name': 'Agregar nombre del cliente',
    'Save customer name': 'Guardar nombre del cliente',
    'Loading complaint details...': 'Cargando detalles del reclamo...',
    'Total Complaints from this Customer': 'Total de reclamos de este cliente',
    'Repair Assignment': 'Asignación de reparación',
    'Repair Order ID': 'ID de orden de reparación',
    'Current Technician': 'Técnico actual',
    'Not assigned': 'Sin asignar',
    'Repair Order Details': 'Detalles de la orden de reparación',
    'Time Consumed': 'Tiempo consumido',
    'Closed At': 'Cerrado el',
    'Spare Part Requests for this Ticket': 'Solicitudes de repuestos para este ticket',
    'No spare part requests linked to this complaint yet.': 'Todavía no hay solicitudes de repuestos vinculadas a este reclamo.',
    'Approve': 'Aprobar',
    'Reject': 'Rechazar',
    'Logs': 'Registros',
    'Image Preview': 'Vista previa de imagen',
    'Preview': 'Vista previa',
    'Review Comment': 'Comentario de revisión',
    'Reviewed At': 'Revisado el',
    'Approved By': 'Aprobado por',
    'Qty': 'Cant.',
    'System': 'Sistema',
    'Customer': 'Cliente',
    'You': 'Tú',
    'Take Photo': 'Tomar foto',
    'Choose from Gallery': 'Elegir de la galería',
    'Choose Another': 'Elegir otra',
    'Photo selected': 'Foto seleccionada',
    'Only image files are allowed.': 'Solo se permiten archivos de imagen.',
    'This phone photo format could not be processed. Please try another photo or retake it.': 'No se pudo procesar este formato de foto del teléfono. Intenta con otra foto o vuelve a tomarla.',
    'Photo size limit reached. Maximum': 'Se alcanzó el límite de tamaño de la foto. Máximo',
    'per photo.': 'por foto.',
    'Photo could not be processed. Please try again with another photo.': 'No se pudo procesar la foto. Inténtalo de nuevo con otra imagen.',
    'Could not read file': 'No se pudo leer el archivo',
    'Could not load image': 'No se pudo cargar la imagen',
    'Admin connection and sync management': 'Administración de conexión y sincronización',
    'Business unit': 'Unidad de negocio',
    'Consolidated': 'Consolidado',
    'Foods': 'Foods',
    'Coffee & Vending': 'Coffee & Vending',
    'Select unit': 'Selecciona unidad',
    'Disconnected': 'Desconectado',
    'Connected': 'Conectado',
    'Needs attention': 'Requiere atención',
    'Review connection': 'Revisar conexión',
    'QuickBooks connected successfully': 'QuickBooks conectado correctamente',
    'QuickBooks connection failed': 'Falló la conexión con QuickBooks',
    'Select a business unit first': 'Selecciona primero una unidad de negocio',
    'Seller filter': 'Vendedor',
    'All team': 'Todo el equipo',
    'Hide Data': 'Ocultar datos',
    'Data': 'Datos',
    'Quotas': 'Cuotas',
    'Manage': 'Administrar',
    'Reconnect': 'Reconectar',
    'Connect': 'Conectar',
    'Comercial dashboard requires a specific business unit. Consolidated is not available for this endpoint.': 'El panel comercial requiere una unidad de negocio específica. Consolidado no está disponible para este endpoint.',
    'This dashboard requires a specific business unit. Consolidated is not available for this endpoint.': 'Este panel requiere una unidad de negocio específica. Consolidado no está disponible para este endpoint.',
    'The end date must be on or after the start date.': 'La fecha final debe ser igual o posterior a la fecha inicial.',
    'Selected period': 'Periodo seleccionado',
    'Invoices ($)': 'Facturas ($)',
    'Credit Notes ($)': 'Notas de crédito ($)',
    'Net Sales': 'Ventas netas',
    'Net sales': 'Ventas netas',
    'net sales': 'ventas netas',
    'Collected amount': 'Cobrado',
    'Accounts Receivables': 'Cuentas por cobrar',
    'Overdue Accounts Receivable': 'Cuentas por cobrar vencidas',
    'Accounts Payables': 'Cuentas por pagar',
    'Total cobrado': 'Total cobrado',
    '% cobrado': '% cobrado',
    'DPO': 'DPO',
    'Average Accounts Payable': 'CxP promedio',
    'Balance Sheet beginning and ending balance': 'Balance general: saldo inicial y final',
    'Vendor Bills': 'Bills de proveedores',
    'Bills registered in the selected period': 'Facturas de proveedores registradas en el periodo',
    'Average Inventory': 'Inventario promedio',
    'Inventory Asset beginning and ending balance': 'Activo de inventario: saldo inicial y final',
    'DIO': 'DIO',
    'Days inventory outstanding': 'Dias promedio de inventario',
    'CCC': 'CCC',
    'Cash Conversion Cycle': 'Ciclo de conversión de caja',
    'Cumple': 'Cumple',
    'Disponible': 'Disponible',
    'No disponible': 'No disponible',
    'Requires DIO, DSO and DPO': 'Requiere DIO, DSO y DPO',
    'Open A/R / daily net sales': 'CxC abierta / ventas netas diarias',
    'QuickBooks invoices and receivables aging': 'Facturas de QuickBooks y antigüedad de CxC',
    'Average inventory / cost of sales x period days': 'Inventario promedio / costo de ventas x dias del periodo',
    'Balance Sheet inventory and ProfitAndLoss COGS': 'Balance general: inventario y P&L: costo de ventas',
    'Average A/P / vendor bills x period days': 'CxP promedio / Bills de proveedores x dias del periodo',
    'Balance Sheet A/P and QuickBooks Bills': 'Balance general: CxP y Bills de QuickBooks',
    'DIO + DSO - DPO': 'DIO + DSO - DPO',
    'Calculated from DIO, DSO and DPO': 'Calculado desde DIO, DSO y DPO',
    'No cash conversion cycle data available': 'No hay datos disponibles para el ciclo de conversión de caja',
    'No cash conversion cycle inputs available': 'No hay datos base disponibles para el ciclo de conversión de caja',
    'Accounts Payable start': 'CxP inicial',
    'Accounts Payable end': 'CxP final',
    'Inventory start': 'Inventario inicial',
    'Inventory end': 'Inventario final',
    'Cost of sales': 'Costo de ventas',
    'Balance Sheet opening date': 'Balance general: fecha inicial',
    'Balance Sheet closing date': 'Balance general: fecha final',
    'ProfitAndLoss cost of sales': 'P&L: costo de ventas',
    'Métrica': 'Métrica',
    'Días': 'Días',
    'Fórmula': 'Fórmula',
    'Fuente': 'Fuente',
    'Dato base': 'Dato base',
    'Valor': 'Valor',
    'Target': 'Meta',
    'Open vendor bills through the date cutoff': 'Facturas abiertas de proveedores hasta el corte de fecha',
    'Days payable outstanding by business unit': 'Días promedio para pagar proveedores según Bills del periodo',
    'DPO uses only Bills registered in QuickBooks; direct bank or petty cash payments are not included.': 'DPO usa solo Bills registrados en QuickBooks; pagos directos por banco o caja chica no están incluidos.',
    'Cash Flow Projection': 'Proyección de flujo de caja',
    'Editable assumptions': 'Supuestos editables',
    'Settings': 'Ajustes',
    'Apply': 'Aplicar',
    'Manual collections': 'Cobros manuales',
    'Manual payments': 'Pagos manuales',
    'Vendor payment day 1': 'Día pago proveedores 1',
    'Vendor payment day 2': 'Día pago proveedores 2',
    'Fixed expense day': 'Día gastos fijos',
    'Starting cash': 'Caja inicial',
    'Operating bank accounts only': 'Solo cuentas bancarias operativas',
    'Minimum projected cash': 'Caja mínima proyectada',
    'Minimum liquidity': 'Liquidez mínima',
    'Critical week': 'Semana crítica',
    'No projection data available': 'No hay datos de proyección disponibles',
    'Accounts receivable detail does not reconcile with the official QuickBooks total.': 'El detalle de CxC no concilia con el total oficial de QuickBooks.',
    'Official total': 'Total oficial',
    'Detail used': 'Detalle utilizado',
    'Review this difference before using the projection for decisions.': 'Revise esta diferencia antes de usar la proyección para tomar decisiones.',
    'No cash flow projection data available': 'No hay datos disponibles para la proyección de flujo de caja',
    'Cobros esperados': 'Cobros esperados',
    'Cartera programada': 'Cartera programada',
    'Probabilidad ponderada': 'Probabilidad ponderada',
    'Cobros manuales': 'Cobros manuales',
    'Bills proveedores': 'Bills proveedores',
    'Pagos manuales': 'Pagos manuales',
    'Gastos fijos': 'Gastos fijos',
    'Préstamos/intereses': 'Préstamos/intereses',
    'Reserva autos': 'Reserva autos',
    'Caja final': 'Caja final',
    'Liquidez': 'Liquidez',
    'Verde': 'Verde',
    'Amarillo': 'Amarillo',
    'Rojo': 'Rojo',
    'No collection probability data available': 'No hay datos de probabilidad de cobranza disponibles',
    'Bucket CxC': 'Bucket CxC',
    'Monto abierto': 'Monto abierto',
    'Probabilidad': 'Probabilidad',
    'Cobro esperado': 'Cobro esperado',
    'No operating bank accounts available': 'No hay cuentas bancarias operativas disponibles',
    'Cuenta banco': 'Cuenta banco',
    'Saldo': 'Saldo',
    'Expected collections detail': 'Detalle de cobros esperados',
    'No projected collections for this week': 'No hay cobros proyectados para esta semana',
    'Probability': 'Probabilidad',
    'Manual review': 'Revisión manual',
    'Aging fallback': 'Supuesto por antigüedad',
    'Cash flow projection uses invoice-level A/R, Monday-Saturday weeks, open Bills, trailing three-month fixed expenses, financial outflows and vehicle maintenance reserve.': 'La proyección usa CxC por factura, semanas de lunes a sábado, Bills abiertos, gastos fijos promedio de 3 meses, salidas financieras y reserva de mantenimiento de autos.',
    'Margen Bruto': 'Margen Bruto',
    'Margen Neto': 'Margen Neto',
    'ProfitAndLoss gross profit over net sales': 'P&L: beneficio bruto sobre ventas netas',
    'ProfitAndLoss net income over net sales': 'P&L: utilidad neta sobre ventas netas',
    'Accrual vs Cash': 'Accrual vs Cash',
    'Ventas Netas': 'Ventas Netas',
    'Cobrado': 'Cobrado',
    'Accrual for selected period': 'Accrual del periodo seleccionado',
    'Cash received in selected period': 'Cash recibido en el periodo seleccionado',
    'Cash vs Accrual': 'Cash vs Accrual',
    'Collected exceeds net sales by': 'Cobrado excede ventas netas por',
    'Collected is below net sales by': 'Cobrado está por debajo de ventas netas por',
    'Period collections may include invoices from prior months.': 'Cobros del periodo pueden incluir facturas de meses anteriores.',
    'Presupuesto vs Real': 'Presupuesto vs Real',
    'Presupuesto gastos': 'Presupuesto gastos',
    'Real gastos': 'Real gastos',
    'ProfitAndLoss actuals': 'ProfitAndLoss reales',
    'Variación': 'Variación',
    '% variación': '% variación',
    'Umbral': 'Umbral',
    'Estado': 'Estado',
    'Presupuesto': 'Presupuesto',
    'Real': 'Real',
    'Categoría': 'Categoría',
    'Dentro de meta': 'Dentro de meta',
    'Revisar': 'Revisar',
    'Fuera de meta': 'Fuera de meta',
    'Sin presupuesto': 'Sin presupuesto',
    'No budget variance data available': 'No hay datos de presupuesto vs real disponibles',
    'Conciliación Coffee & Vending': 'Conciliación Coffee & Vending',
    'Parlevel cobrado': 'Parlevel cobrado',
    'QuickBooks cobrado': 'QuickBooks cobrado',
    'CustomerSalesDetail cash basis': 'CustomerSalesDetail cash basis',
    'Diferencia': 'Diferencia',
    'Exactitud': 'Exactitud',
    'Transacciones': 'Transacciones',
    'Semana': 'Semana',
    'No reconciliation data available': 'No hay datos de conciliación disponibles',
    'Match': 'Match',
    'Solo Parlevel': 'Solo Parlevel',
    'Solo QuickBooks': 'Solo QuickBooks',
    'Open receivables through the date cutoff': 'Cuentas por cobrar abiertas hasta el corte de fecha',
    'Days sales outstanding by business unit': 'Días promedio para cobrar ventas pendientes',
    'Collected vs net sales for selected period': 'Cobrado vs ventas netas del periodo seleccionado',
    'Collection rate': 'Tasa de cobro',
    '% Collected': '% Cobrado',
    'Collected vs net sales': 'Cobrado vs ventas netas',
    'Quota': 'Cuota',
    'quota': 'cuota',
    'Attainment': 'Cumplimiento',
    'attainment': 'cumplimiento',
    'Quota Achievement (%)': 'Cumplimiento cuota (%)',
    'Sales vs monthly quote': 'Ventas vs cuota mensual',
    'Projected Close': 'Cierre proyectado',
    'Projected Attainment': 'Cumplimiento proyectado',
    'Projected Quota Achievement (%)': 'Cumplimiento proyectado de cuota (%)',
    'Projected close vs quota': 'Cierre proyectado vs cuota',
    'Gross sales': 'Ventas brutas',
    'Days sales outstanding': 'Dias de ventas pendientes de cobro',
    'Sales vs quota': 'Ventas vs cuota',
    'Sales by Seller': 'Ventas por vendedor',
    'Sellers at 90% quota': 'Vendedores en 90% de cuota',
    'of': 'de',
    'sellers at >=90% of their quota': 'vendedores en >=90% de su cuota',
    'sellers on pace': 'vendedores en ritmo',
    'Quota Pace': 'Proyección de cumplimiento',
    'Current daily run rate': 'Ritmo diario actual',
    'Projected month close': 'Proyección cierre mes',
    'Projected week close': 'Proyección cierre semana',
    'Projected attainment': 'Cumplimiento proyectado',
    'Required daily to close': 'Ritmo diario requerido',
    'No quota pace data available': 'No hay datos de ritmo de cuota disponibles',
    'On pace': 'En ritmo',
    'Watch': 'Atención',
    'Behind': 'Atrasado',
    'No quota': 'Sin cuota',
    'Customers below purchase pace': 'Clientes bajo su ritmo de compra',
    'Customers at risk': 'Clientes en riesgo',
    'Estimated gap': 'Brecha estimada',
    'Critical customers': 'Clientes críticos',
    'Average drop': 'Caída promedio',
    'drop vs trailing average': 'caída vs promedio móvil',
    'current purchase vs average': 'compra actual vs promedio',
    'highest urgency': 'mayor urgencia',
    'at-risk customers': 'clientes en riesgo',
    'Importance': 'Importancia',
    'Current purchase': 'Compra actual',
    'Trailing 3-month average': 'Promedio móvil 3 meses',
    'Drop': 'Caída',
    'Last purchase': 'Última compra',
    'High': 'Alta',
    'Medium': 'Media',
    'Low': 'Baja',
    'No repurchase alerts available': 'No hay alertas de recompra disponibles',
    'Accounts Receivable Aging': 'Cuentas por cobrar',
    'Accounts Payable Aging': 'Cuentas por pagar',
    'All': 'Todos',
    'Days range': 'Rango de dias',
    '0-30 days': '0-30 dias',
    '31-60 days': '31-60 dias',
    '61-90 days': '61-90 dias',
    '90+ days': '90+ dias',
    'invoices': 'facturas',
    'open invoices': 'facturas abiertas',
    'bills': 'facturas de proveedor',
    'open bills': 'facturas de proveedor abiertas',
    'No receivables available': 'No hay cuentas por cobrar disponibles',
    'No payables available': 'No hay cuentas por pagar disponibles',
    'Review': 'Revisión',
    'Revisado': 'Revisado',
    'Edit review': 'Editar revisión',
    'Receivable review': 'Revisión de cuenta por cobrar',
    'Reviewed amount': 'Monto revisado',
    'Payment probability': 'Probabilidad de pago',
    'Expected collection': 'Cobro esperado',
    'Expected collection date': 'Fecha esperada de cobro',
    'Expected date': 'Fecha esperada',
    'Finance weeks run from Monday through Saturday.': 'Las semanas de Finanzas van de lunes a sábado.',
    'Cutoff': 'Corte',
    'Payment status': 'Estado de pago',
    'Follow-up': 'Seguimiento',
    'Edit follow-up': 'Editar seguimiento',
    'Payable follow-up': 'Seguimiento de cuenta por pagar',
    'Partial payment': 'Abono parcial',
    'Estimated remaining': 'Saldo estimado',
    'Pendiente': 'Pendiente',
    'Agendado': 'Agendado',
    'Pagado parcial': 'Pagado parcial',
    'Retener': 'Retener',
    'En disputa': 'En disputa',
    'Invoice': 'Factura',
    'Invoice #': '# Factura',
    'Bill #': '# Factura',
    'Vendor': 'Proveedor',
    'Due date': 'Fecha de vencimiento',
    'Days overdue': 'Días vencidos',
    'Bucket': 'Bucket',
    'Range': 'Rango',
    'Open amount': 'Monto pendiente',
    'No commercial data available': 'No hay datos comerciales disponibles',
    'customers': 'clientes',
    'categories': 'categorías',
    'Expand section': 'Expandir sección',
    'Collapse section': 'Colapsar sección',
    'Seller': 'Vendedor',
    'Invoices': 'Facturas',
    'Customers': 'Clientes',
    'Credit memos': 'Notas de crédito',
    'Totals': 'Totales',
    'Top Customers': 'Clientes principales',
    'Show all': 'Ver todos',
    'Show top 10': 'Ver top 10',
    'Edit customer quotas': 'Editar cuotas de clientes',
    'Customer Quotas': 'Cuotas por cliente',
    'Enter the monthly quota per active customer for the selected period.': 'Ingresa la cuota mensual por cliente activo para el periodo seleccionado.',
    'No customer data available': 'No hay datos de clientes disponibles',
    'Share': 'Participación',
    'Product Mix': 'Product Mix',
    'Product': 'Producto',
    'Sales': 'Ventas',
    '% of total sales': '% de venta total',
    'No product data available': 'No hay datos de productos disponibles',
    'Commercial Summary': 'Resumen comercial',
    'Period month': 'Mes del periodo',
    'Invoices used': 'Facturas usadas',
    'Credit memos used': 'Notas de crédito usadas',
    'Payments used': 'Pagos usados',
    'Trend vs Previous Month': 'Tendencia vs mismo periodo del mes anterior',
    'No trend data available': 'No hay datos de tendencia disponibles',
    'Current': 'Actual',
    'Previous month': 'Mes anterior',
    'dashboard structure is reserved here. Comercial is the only team implemented in this pass.': 'tiene reservada aquí la estructura del panel. Comercial es el único equipo implementado en esta versión.',
    'Connection Status': 'Estado de conexión',
    'Duplicate active QuickBooks realm assignments were detected across business units. Review the warnings column before reconnecting anything.': 'Se detectaron asignaciones activas duplicadas de realms de QuickBooks entre unidades de negocio. Revisa la columna de advertencias antes de reconectar.',
    'No business units available': 'No hay unidades de negocio disponibles',
    'Connected at': 'Conectado el',
    'Last refresh': 'Última actualización',
    'Warnings': 'Advertencias',
    'Company': 'Compañía',
    'Company name': 'Nombre de la compañía',
    'Legal name': 'Nombre legal',
    'Country': 'País',
    'Run Sync': 'Ejecutar sincronización',
    'Disconnect': 'Desconectar',
    'Sync Summary': 'Resumen de sincronización',
    'No sync summary available': 'No hay resumen de sincronización disponible',
    'Entity': 'Entidad',
    'Last QuickBooks update': 'Última actualización de QuickBooks',
    'Last synced': 'Última sincronización',
    'Recent Sync Logs': 'Registros recientes de sincronización',
    'No sync logs available': 'No hay registros de sincronización disponibles',
    'Mode': 'Modo',
    'Fetched': 'Obtenidos',
    'Upserted': 'Actualizados/insertados',
    'Error': 'Error',
    'Entities': 'Entidades',
    'No entities available': 'No hay entidades disponibles',
    'Balance': 'Balance',
    'Updated': 'Actualizado',
    'Customer Quarterly Quotas': 'Cuotas trimestrales de clientes principales',
    'Quarter Quotas': 'Cuotas trimestrales',
    'Year': 'Año',
    'Quarter': 'Trimestre',
    'Reload': 'Recargar',
    'Even split': 'Dividir equitativamente',
    'Enter the quarterly quota per seller. Monthly allocations can stay evenly split or be adjusted manually.': 'Ingresa la cuota trimestral por vendedor. Las asignaciones mensuales pueden quedar divididas equitativamente o ajustarse manualmente.',
    'Enter the quarterly quota per customer. Monthly allocations can be split evenly or adjusted manually.': 'Ingresa la cuota trimestral por cliente. Las asignaciones mensuales pueden quedar divididas equitativamente o ajustarse manualmente.',
    'No sellers available for this business unit': 'No hay vendedores disponibles para esta unidad de negocio',
    'Quarter total': 'Total trimestral',
    'All routes for': 'Todas las rutas de',
    'selected operator': 'operador seleccionado',
    'Select an operator to view their operation and weekly OKR results.': 'Selecciona un operador para ver su operación y resultados OKR de la semana.',
    'No linked Parlevel identity was found for this operator.': 'No se encontró una identidad Parlevel vinculada para este operador.',
    'Parlevel driver ID': 'ID del conductor en Parlevel',
    'Parlevel driver name': 'Nombre del conductor en Parlevel',
    'Use the exact driver identity shown in Parlevel.': 'Usa la identidad exacta del conductor que aparece en Parlevel.',
    'Parlevel driver ID must be an integer': 'El ID del conductor en Parlevel debe ser un número entero',
    'Parlevel driver ID must be positive': 'El ID del conductor en Parlevel debe ser positivo',
    'Parlevel driver name is too long': 'El nombre del conductor en Parlevel es demasiado largo'
};

const SPANISH_UI_TOKENS = {
    open: 'Abierta',
    completed: 'Completada',
    closed: 'Cerrada',
    active: 'Activo',
    deleted: 'Eliminado',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    scheduled: 'Programada',
    'in progress': 'En progreso',
    missed: 'Incumplida',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    success: 'Éxito',
    failed: 'Fallido',
    warning: 'Advertencia',
    disconnected: 'Desconectado',
    connected: 'Conectado'
};

export const translateUiText = (value, language = 'es') => {
    if (language !== 'es') return value;
    return SPANISH_UI_TEXT[value] || value;
};

export const translateUiToken = (value, language = 'es') => {
    const displayValue = String(value || '-');
    if (language !== 'es') return displayValue;
    return SPANISH_UI_TOKENS[displayValue.toLowerCase()] || translateUiText(displayValue, language);
};
